import { ReactComponent as FlagNetherlands } from "../styles/svg/flags/netherlands.svg";
import { ReactComponent as FlagBritain } from "../styles/svg/flags/britain.svg";
import { ReactComponent as FlagGermany } from "../styles/svg/flags/germany.svg";
import { ReactComponent as FlagFrance } from "../styles/svg/flags/france.svg";
import { ReactComponent as FlagSpain } from "../styles/svg/flags/spain.svg";
import { ReactComponent as FlagPoland } from "../styles/svg/flags/poland.svg";
import { ReactComponent as FlagUkraine } from "../styles/svg/flags/ukraine.svg";

export const countriesFromLocale = (locale, includeEU = false) => {
    switch(locale) {
        case "en" : return countryListEN(includeEU);
        case "nl" : return countryListNL(includeEU);
        case "de" : return countryListDE(includeEU);
        case "fr" : return countryListFR(includeEU);
        case "es" : return countryListES(includeEU);
        case "pt" : return countryListPT(includeEU);
        case "fi" : return countryListFI(includeEU);
        case "nb" : return countryListNB(includeEU);
        case "da" : return countryListDA(includeEU);
        case "sv" : return countryListSV(includeEU);
    }

    return [];
}

export const countriesForDropdown = (locale, includeEU = false) => {
    const countries = countriesFromLocale(locale, includeEU);
    return countries.map(country => ({
        id: country.alpha2,
        name: country.name,
        value: country.alpha2,
    }));
}

// The languages the return portal ships translation files for. Return reasons can be
// translated into each of these. The locale is the portal's own key; alpha2 is only the
// country whose name and flag label it, which differs for English.
export const returnPortalLanguages = [
    {locale:"nl", alpha2:"nl", flag: <FlagNetherlands/>},
    {locale:"en", alpha2:"gb", flag: <FlagBritain/>},
    {locale:"de", alpha2:"de", flag: <FlagGermany/>},
    {locale:"fr", alpha2:"fr", flag: <FlagFrance/>},
    {locale:"es", alpha2:"es", flag: <FlagSpain/>},
    {locale:"pl", alpha2:"pl", flag: <FlagPoland/>},
    {locale:"ua", alpha2:"ua", flag: <FlagUkraine/>},
];

// A return reason with no text for the shopper's language falls back to this locale, and
// then to the reason's own description.
export const returnPortalFallbackLanguage = "en";

// The languages an email template can render its shortcodes in (tracking button label,
// products table headers, mail shell lines). Named in their own language; the set must
// match the backend's email_template_language enum, which validates the saved value.
export const emailTemplateLanguages = [
    { locale: "nl", name: "Nederlands" },
    { locale: "en", name: "English" },
    { locale: "de", name: "Deutsch" },
    { locale: "fr", name: "Français" },
    { locale: "es", name: "Español" },
    { locale: "it", name: "Italiano" },
    { locale: "pt", name: "Português" },
    { locale: "da", name: "Dansk" },
    { locale: "sv", name: "Svenska" },
    { locale: "nb", name: "Norsk" },
    { locale: "fi", name: "Suomi" },
    { locale: "pl", name: "Polski" },
];

// The portal languages named in the given locale, so the admin sees them in their own UI
// language. Falls back to the bare locale key if the country list does not have a name.
export const returnPortalLanguagesFromLocale = (locale) => {
    const countries = countriesFromLocale(locale);
    return returnPortalLanguages.map(language => {
        const country = countries.find(c => c.alpha2 === language.alpha2);
        let name = language.locale.toUpperCase();
        if (country) {
            name = country.name;
        }

        return {
            locale: language.locale,
            flag: language.flag,
            name: name,
        };
    });
}

const countryListEN = (includeEU = false) => {
    return [
    {"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},
    {"id":8,"alpha2":"al","alpha3":"alb","name":"Albania"},
    {"id":12,"alpha2":"dz","alpha3":"dza","name":"Algeria"},
    {"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},
    {"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},
    {"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua and Barbuda"},
    {"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},
    {"id":51,"alpha2":"am","alpha3":"arm","name":"Armenia"},
    {"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},
    {"id":36,"alpha2":"au","alpha3":"aus","name":"Australia"},
    {"id":40,"alpha2":"at","alpha3":"aut","name":"Austria"},
    {"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbaijan"},

    {"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},
    {"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrain"},
    {"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},
    {"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},
    {"id":112,"alpha2":"by","alpha3":"blr","name":"Belarus"},
    {"id":56,"alpha2":"be","alpha3":"bel","name":"Belgium"},
    {"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},
    {"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},
    {"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},

    {"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia (Plurinational State of)"},
    {"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, Sint Eustatius and Saba"},
    {"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnia and Herzegovina"},

    {"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},
    {"id":76,"alpha2":"br","alpha3":"bra","name":"Brazil"},
    {"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei Darussalam"},
    {"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgaria"},
    {"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},
    {"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},

    {"id":132,"alpha2":"cv","alpha3":"cpv","name":"Cabo Verde"},
    {"id":116,"alpha2":"kh","alpha3":"khm","name":"Cambodia"},
    {"id":120,"alpha2":"cm","alpha3":"cmr","name":"Cameroon"},
    {"id":124,"alpha2":"ca","alpha3":"can","name":"Canada"},
    {"id":9001,"alpha2":"ic","alpha3":"ic","name":"Canary Islands"},
    {"id":140,"alpha2":"cf","alpha3":"caf","name":"Central African Republic"},
    {"id":148,"alpha2":"td","alpha3":"tcd","name":"Chad"},
    {"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},
    {"id":156,"alpha2":"cn","alpha3":"chn","name":"China"},
    {"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},
    {"id":174,"alpha2":"km","alpha3":"com","name":"Comoros"},
    {"id":178,"alpha2":"cg","alpha3":"cog","name":"Congo"},
    {"id":180,"alpha2":"cd","alpha3":"cod","name":"Congo, Democratic Republic of the"},
    {"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},
    {"id":384,"alpha2":"ci","alpha3":"civ","name":"Côte d'Ivoire"},
    {"id":191,"alpha2":"hr","alpha3":"hrv","name":"Croatia"},
    {"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},
    {"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},
    {"id":196,"alpha2":"cy","alpha3":"cyp","name":"Cyprus"},
    {"id":203,"alpha2":"cz","alpha3":"cze","name":"Czechia"},

    {"id":208,"alpha2":"dk","alpha3":"dnk","name":"Denmark"},
    {"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},
    {"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},
    {"id":214,"alpha2":"do","alpha3":"dom","name":"Dominican Republic"},

    {"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},
    {"id":818,"alpha2":"eg","alpha3":"egy","name":"Egypt"},
    {"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},
    {"id":226,"alpha2":"gq","alpha3":"gnq","name":"Equatorial Guinea"},
    {"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},
    {"id":233,"alpha2":"ee","alpha3":"est","name":"Estonia"},
    {"id":748,"alpha2":"sz","alpha3":"swz","name":"Eswatini"},
    {"id":231,"alpha2":"et","alpha3":"eth","name":"Ethiopia"},

    ...(includeEU ? [{"id":999,"alpha2":"eu","alpha3":"eur","name":"European Union"}] : []),

    {"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiji"},
    {"id":234,"alpha2":"fo","alpha3":"fro","name":"Faroe Islands"},
    {"id":246,"alpha2":"fi","alpha3":"fin","name":"Finland"},
    {"id":250,"alpha2":"fr","alpha3":"fra","name":"France"},

    {"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},
    {"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},
    {"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgia"},
    {"id":276,"alpha2":"de","alpha3":"deu","name":"Germany"},
    {"id":276,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},
    {"id":304,"alpha2":"gl","alpha3":"grl","name":"Greenland"},
    {"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},
    {"id":300,"alpha2":"gr","alpha3":"grc","name":"Greece"},
    {"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},

    {"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},
    {"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},
    {"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bissau"},
    {"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},

    {"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},
    {"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},
    {"id":348,"alpha2":"hu","alpha3":"hun","name":"Hungary"},

    {"id":352,"alpha2":"is","alpha3":"isl","name":"Iceland"},
    {"id":356,"alpha2":"in","alpha3":"ind","name":"India"},
    {"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesia"},
    {"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran (Islamic Republic of)"},
    {"id":368,"alpha2":"iq","alpha3":"irq","name":"Iraq"},
    {"id":372,"alpha2":"ie","alpha3":"irl","name":"Ireland"},
    {"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},
    {"id":380,"alpha2":"it","alpha3":"ita","name":"Italy"},

    {"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},
    {"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japan"},
    {"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordan"},

    {"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazakhstan"},
    {"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenya"},
    {"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},
    {"id":383,"alpha2":"xk","alpha3":"xkx","name":"Kosovo"},
    {"id":408,"alpha2":"kp","alpha3":"prk","name":"Korea (Democratic People's Republic of)"},
    {"id":410,"alpha2":"kr","alpha3":"kor","name":"Korea, Republic of"},
    {"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},
    {"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kyrgyzstan"},

    {"id":418,"alpha2":"la","alpha3":"lao","name":"Lao People's Democratic Republic"},
    {"id":428,"alpha2":"lv","alpha3":"lva","name":"Latvia"},
    {"id":422,"alpha2":"lb","alpha3":"lbn","name":"Lebanon"},
    {"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},
    {"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},
    {"id":434,"alpha2":"ly","alpha3":"lby","name":"Libya"},
    {"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},
    {"id":440,"alpha2":"lt","alpha3":"ltu","name":"Lithuania"},
    {"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxembourg"},

    {"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagascar"},
    {"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},
    {"id":458,"alpha2":"my","alpha3":"mys","name":"Malaysia"},
    {"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldives"},
    {"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},
    {"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},
    {"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshall Islands"},
    {"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritania"},
    {"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},
    {"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexico"},
    {"id":583,"alpha2":"fm","alpha3":"fsm","name":"Micronesia (Federated States of)"},

    {"id":498,"alpha2":"md","alpha3":"mda","name":"Moldova, Republic of"},
    {"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},
    {"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolia"},
    {"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},
    {"id":504,"alpha2":"ma","alpha3":"mar","name":"Morocco"},
    {"id":508,"alpha2":"mz","alpha3":"moz","name":"Mozambique"},

    {"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},
    {"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},
    {"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},
    {"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},
    {"id":528,"alpha2":"nl","alpha3":"nld","name":"Netherlands"},
    {"id":554,"alpha2":"nz","alpha3":"nzl","name":"New Zealand"},
    {"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},
    {"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},
    {"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},
    {"id":807,"alpha2":"mk","alpha3":"mkd","name":"North Macedonia"},
    {"id":578,"alpha2":"no","alpha3":"nor","name":"Norway"},

    {"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},

    {"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},
    {"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},
    {"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},
    {"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},
    {"id":598,"alpha2":"pg","alpha3":"png","name":"Papua New Guinea"},
    {"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},
    {"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},
    {"id":608,"alpha2":"ph","alpha3":"phl","name":"Philippines"},
    {"id":616,"alpha2":"pl","alpha3":"pol","name":"Poland"},
    {"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},

    {"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},

    {"id":642,"alpha2":"ro","alpha3":"rou","name":"Romania"},
    {"id":643,"alpha2":"ru","alpha3":"rus","name":"Russian Federation"},
    {"id":646,"alpha2":"rw","alpha3":"rwa","name":"Rwanda"},

    {"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint Kitts and Nevis"},
    {"id":662,"alpha2":"lc","alpha3":"lca","name":"Saint Lucia"},
    {"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint Vincent and the Grenadines"},
    {"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},
    {"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},
    {"id":678,"alpha2":"st","alpha3":"stp","name":"Sao Tome and Principe"},
    {"id":682,"alpha2":"sa","alpha3":"sau","name":"Saudi Arabia"},
    {"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},
    {"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbia"},
    {"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychelles"},
    {"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},
    {"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapore"},
    {"id":703,"alpha2":"sk","alpha3":"svk","name":"Slovakia"},
    {"id":705,"alpha2":"si","alpha3":"svn","name":"Slovenia"},

    {"id":90,"alpha2":"sb","alpha3":"slb","name":"Solomon Islands"},
    {"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},
    {"id":710,"alpha2":"za","alpha3":"zaf","name":"South Africa"},
    {"id":728,"alpha2":"ss","alpha3":"ssd","name":"South Sudan"},
    {"id":724,"alpha2":"es","alpha3":"esp","name":"Spain"},
    {"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},
    {"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudan"},
    {"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},
    {"id":752,"alpha2":"se","alpha3":"swe","name":"Sweden"},
    {"id":756,"alpha2":"ch","alpha3":"che","name":"Switzerland"},
    {"id":760,"alpha2":"sy","alpha3":"syr","name":"Syrian Arab Republic"},

    {"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tajikistan"},
    {"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania, United Republic of"},
    {"id":764,"alpha2":"th","alpha3":"tha","name":"Thailand"},
    {"id":626,"alpha2":"tl","alpha3":"tls","name":"Timor-Leste"},
    {"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},
    {"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},
    {"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad and Tobago"},
    {"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunisia"},
    {"id":792,"alpha2":"tr","alpha3":"tur","name":"Türkiye"},
    {"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},
    {"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},

    {"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},
    {"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraine"},

    {"id":784,"alpha2":"ae","alpha3":"are","name":"United Arab Emirates"},
    {"id":826,"alpha2":"gb","alpha3":"gbr","name":"United Kingdom"},
    {"id":840,"alpha2":"us","alpha3":"usa","name":"United States of America"},

    {"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},
    {"id":860,"alpha2":"uz","alpha3":"uzb","name":"Uzbekistan"},

    {"id":336,"alpha2":"va","alpha3":"vat","name":"Vatican City"},
    {"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},
    {"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela (Bolivarian Republic of)"},
    {"id":704,"alpha2":"vn","alpha3":"vnm","name":"Viet Nam"},

    {"id":887,"alpha2":"ye","alpha3":"yem","name":"Yemen"},
    {"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},
    {"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"}
    ];
};

const countryListNL = (includeEU = false) => {
    return [
    {"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},
    {"id":8,"alpha2":"al","alpha3":"alb","name":"Albanië"},
    {"id":12,"alpha2":"dz","alpha3":"dza","name":"Algerije"},
    {"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},
    {"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},
    {"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua en Barbuda"},
    {"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentinië"},
    {"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},
    {"id":51,"alpha2":"am","alpha3":"arm","name":"Armenië"},
    {"id":36,"alpha2":"au","alpha3":"aus","name":"Australië"},
    {"id":40,"alpha2":"at","alpha3":"aut","name":"Oostenrijk"},
    {"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbeidzjan"},

    {"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahama's"},
    {"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrein"},
    {"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},
    {"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},

    {"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, Sint Eustatius en Saba"},
    {"id":56,"alpha2":"be","alpha3":"bel","name":"België"},
    {"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},
    {"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},
    {"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},

    {"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia"},
    {"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnië en Herzegovina"},
    {"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},
    {"id":76,"alpha2":"br","alpha3":"bra","name":"Brazilië"},
    {"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},
    {"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgarije"},
    {"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},
    {"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},

    {"id":132,"alpha2":"cv","alpha3":"cpv","name":"Kaapverdië"},
    {"id":116,"alpha2":"kh","alpha3":"khm","name":"Cambodja"},
    {"id":120,"alpha2":"cm","alpha3":"cmr","name":"Kameroen"},
    {"id":124,"alpha2":"ca","alpha3":"can","name":"Canada"},
    {"id":9001,"alpha2":"ic","alpha3":"ic","name":"Kanarische Eilanden"},
    {"id":140,"alpha2":"cf","alpha3":"caf","name":"Centraal-Afrikaanse Republiek"},
    {"id":148,"alpha2":"td","alpha3":"tcd","name":"Tsjaad"},
    {"id":152,"alpha2":"cl","alpha3":"chl","name":"Chili"},
    {"id":156,"alpha2":"cn","alpha3":"chn","name":"China"},

    {"id":304,"alpha2":"gl","alpha3":"grl","name":"Groenland"},

    {"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},
    {"id":174,"alpha2":"km","alpha3":"com","name":"Comoren"},
    {"id":178,"alpha2":"cg","alpha3":"cog","name":"Congo-Brazzaville"},
    {"id":180,"alpha2":"cd","alpha3":"cod","name":"Congo-Kinshasa"},
    {"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},
    {"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},
    {"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},
    {"id":196,"alpha2":"cy","alpha3":"cyp","name":"Cyprus"},

    {"id":208,"alpha2":"dk","alpha3":"dnk","name":"Denemarken"},
    {"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},
    {"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},
    {"id":214,"alpha2":"do","alpha3":"dom","name":"Dominicaanse Republiek"},

    {"id":276,"alpha2":"de","alpha3":"deu","name":"Duitsland"},
    {"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},
    {"id":818,"alpha2":"eg","alpha3":"egy","name":"Egypte"},

    ...(includeEU ? [{"id":999,"alpha2":"eu","alpha3":"eur","name":"Europese Unie"}] : []),

    {"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},
    {"id":226,"alpha2":"gq","alpha3":"gnq","name":"Equatoriaal-Guinea"},
    {"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},
    {"id":233,"alpha2":"ee","alpha3":"est","name":"Estland"},
    {"id":231,"alpha2":"et","alpha3":"eth","name":"Ethiopië"},

    {"id":234,"alpha2":"fo","alpha3":"fro","name":"Faeröer"},
    {"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiji"},
    {"id":608,"alpha2":"ph","alpha3":"phl","name":"Filipijnen"},
    {"id":246,"alpha2":"fi","alpha3":"fin","name":"Finland"},
    {"id":250,"alpha2":"fr","alpha3":"fra","name":"Frankrijk"},

    {"id":336,"alpha2":"va","alpha3":"vat","name":"Vaticaanstad"},

    {"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},
    {"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},
    {"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgië"},
    {"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},
    {"id":276,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},
    {"id":300,"alpha2":"gr","alpha3":"grc","name":"Griekenland"},
    {"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},

    {"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},
    {"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinee"},
    {"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinee-Bissau"},
    {"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},

    {"id":332,"alpha2":"ht","alpha3":"hti","name":"Haïti"},
    {"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},
    {"id":348,"alpha2":"hu","alpha3":"hun","name":"Hongarije"},

    {"id":372,"alpha2":"ie","alpha3":"irl","name":"Ierland"},
    {"id":352,"alpha2":"is","alpha3":"isl","name":"IJsland"},
    {"id":356,"alpha2":"in","alpha3":"ind","name":"India"},
    {"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesië"},
    {"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},
    {"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},
    {"id":376,"alpha2":"il","alpha3":"isr","name":"Israël"},
    {"id":380,"alpha2":"it","alpha3":"ita","name":"Italië"},

    {"id":384,"alpha2":"ci","alpha3":"civ","name":"Ivoorkust"},
    {"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},
    {"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japan"},
    {"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordanië"},

    {"id":383,"alpha2":"xk","alpha3":"xkx","name":"Kosovo"},

    {"id":414,"alpha2":"kw","alpha3":"kwt","name":"Koeweit"},
    {"id":191,"alpha2":"hr","alpha3":"hrv","name":"Kroatië"},
    {"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},

    {"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},
    {"id":428,"alpha2":"lv","alpha3":"lva","name":"Letland"},
    {"id":422,"alpha2":"lb","alpha3":"lbn","name":"Libanon"},
    {"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},
    {"id":434,"alpha2":"ly","alpha3":"lby","name":"Libië"},
    {"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},
    {"id":440,"alpha2":"lt","alpha3":"ltu","name":"Litouwen"},
    {"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburg"},

    {"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagaskar"},
    {"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},
    {"id":458,"alpha2":"my","alpha3":"mys","name":"Maleisië"},
    {"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldiven"},
    {"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},
    {"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},

    {"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshalleilanden"},
    {"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritanië"},
    {"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},
    {"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexico"},
    {"id":583,"alpha2":"fm","alpha3":"fsm","name":"Micronesië"},

    {"id":498,"alpha2":"md","alpha3":"mda","name":"Moldavië"},
    {"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},
    {"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolië"},
    {"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},

    {"id":535,"alpha2":"bq","alpha3":"bes","name":"Caribisch Nederland"},
    {"id":504,"alpha2":"ma","alpha3":"mar","name":"Marokko"},
    {"id":508,"alpha2":"mz","alpha3":"moz","name":"Mozambique"},

    {"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},
    {"id":516,"alpha2":"na","alpha3":"nam","name":"Namibië"},
    {"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},
    {"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},
    {"id":528,"alpha2":"nl","alpha3":"nld","name":"Nederland"},
    {"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nieuw-Zeeland"},

    {"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},
    {"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},
    {"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},

    {"id":408,"alpha2":"kp","alpha3":"prk","name":"Noord-Korea"},
    {"id":807,"alpha2":"mk","alpha3":"mkd","name":"Noord-Macedonië"},
    {"id":578,"alpha2":"no","alpha3":"nor","name":"Noorwegen"},

    {"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},
    {"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},
    {"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},
    {"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},
    {"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},

    {"id":598,"alpha2":"pg","alpha3":"png","name":"Papoea-Nieuw-Guinea"},
    {"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},
    {"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},
    {"id":616,"alpha2":"pl","alpha3":"pol","name":"Polen"},
    {"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},

    {"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},
    {"id":642,"alpha2":"ro","alpha3":"rou","name":"Roemenië"},
    {"id":643,"alpha2":"ru","alpha3":"rus","name":"Rusland"},
    {"id":646,"alpha2":"rw","alpha3":"rwa","name":"Rwanda"},

    {"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint Kitts en Nevis"},
    {"id":662,"alpha2":"lc","alpha3":"lca","name":"Saint Lucia"},
    {"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint Vincent en de Grenadines"},

    {"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},
    {"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},
    {"id":678,"alpha2":"st","alpha3":"stp","name":"Sao Tomé en Principe"},

    {"id":682,"alpha2":"sa","alpha3":"sau","name":"Saoedi-Arabië"},
    {"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},
    {"id":688,"alpha2":"rs","alpha3":"srb","name":"Servië"},
    {"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychellen"},
    {"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},
    {"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapore"},

    {"id":705,"alpha2":"si","alpha3":"svn","name":"Slovenië"},
    {"id":703,"alpha2":"sk","alpha3":"svk","name":"Slowakije"},

    {"id":729,"alpha2":"sd","alpha3":"sdn","name":"Soedan"},
    {"id":706,"alpha2":"so","alpha3":"som","name":"Somalië"},
    {"id":724,"alpha2":"es","alpha3":"esp","name":"Spanje"},

    {"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},
    {"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},
    {"id":748,"alpha2":"sz","alpha3":"swz","name":"Eswatini"},

    {"id":760,"alpha2":"sy","alpha3":"syr","name":"Syrië"},
    {"id":336,"alpha2":"va","alpha3":"vat","name":"Vaticaanstad"},

    {"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadzjikistan"},
    {"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania"},
    {"id":764,"alpha2":"th","alpha3":"tha","name":"Thailand"},
    {"id":203,"alpha2":"cz","alpha3":"cze","name":"Tsjechië"},

    {"id":626,"alpha2":"tl","alpha3":"tls","name":"Oost-Timor"},
    {"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},
    {"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},
    {"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad en Tobago"},

    {"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunesië"},
    {"id":792,"alpha2":"tr","alpha3":"tur","name":"Turkije"},
    {"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},
    {"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},

    {"id":800,"alpha2":"ug","alpha3":"uga","name":"Oeganda"},
    {"id":804,"alpha2":"ua","alpha3":"ukr","name":"Oekraïne"},

    {"id":784,"alpha2":"ae","alpha3":"are","name":"Verenigde Arabische Emiraten"},
    {"id":826,"alpha2":"gb","alpha3":"gbr","name":"Verenigd Koninkrijk"},
    {"id":840,"alpha2":"us","alpha3":"usa","name":"Verenigde Staten"},

    {"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},
    {"id":860,"alpha2":"uz","alpha3":"uzb","name":"Oezbekistan"},

    {"id":336,"alpha2":"va","alpha3":"vat","name":"Vaticaanstad"},
    {"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},
    {"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},
    {"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},

    {"id":112,"alpha2":"by","alpha3":"blr","name":"Wit-Rusland"},

    {"id":887,"alpha2":"ye","alpha3":"yem","name":"Jemen"},
    {"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},
    {"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"},

    {"id":710,"alpha2":"za","alpha3":"zaf","name":"Zuid-Afrika"},
    {"id":410,"alpha2":"kr","alpha3":"kor","name":"Zuid-Korea"},
    {"id":728,"alpha2":"ss","alpha3":"ssd","name":"Zuid-Soedan"},
    {"id":752,"alpha2":"se","alpha3":"swe","name":"Zweden"},
    {"id":756,"alpha2":"ch","alpha3":"che","name":"Zwitserland"}
    ];
};

// export const regions = [
//     { 
//         id:0,
//         name:"Europa",
//         countries:[
//             "ad","al","at","be","ba","bg","hr","cy","cz","dk","ee","fi","fr",
//             "de","gr","hu","is","ie","it","lv","lt","lu","mt","nl","no","pl",
//             "pt","ro","rs","sk","si","es","se","ch","ua","me","mk"
//         ]
//     },
//     // {
//     //     id:1,
//     //     name:"Afrika",
//     //     countries:[
//     //         "dz","ao","bj","bw","bf","bi","cm","cv","cf","td","km","cg","cd",
//     //         "dj","eg","gq","er","et","ga","gm","gh","gn","gw","ci","ke","ls",
//     //         "lr","ly","mg","mw","ml","mr","mu","ma","mz","na","ne","ng","rw",
//     //         "st","sn","sc","sl","so","za","ss","sd","sz","tz","tg","tn","ug",
//     //         "zm","zw"
//     //     ]
//     // },
//     // {
//     //     id:2,
//     //     name:"Noord Amerika",
//     //     countries:[
//     //         "ca","us","mx","bz","cr","cu","do","gt","ht","hn","jm","ni","pa","sv"
//     //     ]
//     // },
//     // {
//     //     id:3,
//     //     name:"Zuid amerika",
//     //     countries: [
//     //         "ar","bo","br","cl","co","ec","gy","py","pe","sr","uy","ve"
//     //     ]
//     // },
//     // {
//     //     id:4,
//     //     name:"Azië",
//     //     countries: [
//     //         "af","am","az","bh","bd","bt","bn","kh","cn","ge","in","id","ir","iq",
//     //         "il","jp","jo","kz","kw","kg","la","lb","my","mv","mn","mm","np","kp",
//     //         "om","pk","ps","ph","qa","sa","sg","kr","lk","sy","tj","th","tl","tr",
//     //         "tm","ae","uz","vn","ye","iq","ir"
//     //     ]
//     // },
//     // {
//     //     id:5,
//     //     name:"Oceanië",
//     //     countries: [
//     //         "au","fj","ki","mh","fm","nr","nz","pw","pg","sb","ws","to","tv","vu"
//     //     ]
//     // },
//     {
//         id:6,
//         name:"Europese unie",
//         countries:[
//             "at","be","bg","hr","cy","cz","dk","ee","fi","fr","de","gr","hu","ie",
//             "it","lv","lt","lu","mt","nl","pl","pt","ro","sk","si","es","se"
//         ]
//     },
//     // schengen: [ // Schengen Area
//     //     "at","be","cz","dk","ee","fi","fr","de","gr","hu","is","it","lv","lt",
//     //     "lu","mt","nl","no","pl","pt","sk","si","es","se","ch"
//     // ]
// ];
const countryListDE = (includeEU = false) => {
    return [
    {"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},
    {"id":8,"alpha2":"al","alpha3":"alb","name":"Albanien"},
    {"id":12,"alpha2":"dz","alpha3":"dza","name":"Algerien"},
    {"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},
    {"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},
    {"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua und Barbuda"},
    {"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentinien"},
    {"id":51,"alpha2":"am","alpha3":"arm","name":"Armenien"},
    {"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},
    {"id":36,"alpha2":"au","alpha3":"aus","name":"Australien"},
    {"id":40,"alpha2":"at","alpha3":"aut","name":"Österreich"},
    {"id":31,"alpha2":"az","alpha3":"aze","name":"Aserbaidschan"},

    {"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},
    {"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrain"},
    {"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesch"},
    {"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},
    {"id":112,"alpha2":"by","alpha3":"blr","name":"Belarus"},
    {"id":56,"alpha2":"be","alpha3":"bel","name":"Belgien"},
    {"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},
    {"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},
    {"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},

    {"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivien (Plurinationaler Staat)"},
    {"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, Sint Eustatius und Saba"},
    {"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnien und Herzegowina"},

    {"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},
    {"id":76,"alpha2":"br","alpha3":"bra","name":"Brasilien"},
    {"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei Darussalam"},
    {"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgarien"},
    {"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},
    {"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},

    {"id":132,"alpha2":"cv","alpha3":"cpv","name":"Kap Verde"},
    {"id":116,"alpha2":"kh","alpha3":"khm","name":"Kambodscha"},
    {"id":120,"alpha2":"cm","alpha3":"cmr","name":"Kamerun"},
    {"id":124,"alpha2":"ca","alpha3":"can","name":"Kanada"},
    {"id":9001,"alpha2":"ic","alpha3":"ic","name":"Kanarische Inseln"},
    {"id":140,"alpha2":"cf","alpha3":"caf","name":"Zentralafrikanische Republik"},
    {"id":148,"alpha2":"td","alpha3":"tcd","name":"Tschad"},
    {"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},
    {"id":156,"alpha2":"cn","alpha3":"chn","name":"China"},
    {"id":170,"alpha2":"co","alpha3":"col","name":"Kolumbien"},
    {"id":174,"alpha2":"km","alpha3":"com","name":"Komoren"},
    {"id":178,"alpha2":"cg","alpha3":"cog","name":"Kongo"},
    {"id":180,"alpha2":"cd","alpha3":"cod","name":"Kongo, Demokratische Republik"},
    {"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},
    {"id":384,"alpha2":"ci","alpha3":"civ","name":"Côte d'Ivoire"},
    {"id":191,"alpha2":"hr","alpha3":"hrv","name":"Kroatien"},
    {"id":192,"alpha2":"cu","alpha3":"cub","name":"Kuba"},
    {"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},
    {"id":196,"alpha2":"cy","alpha3":"cyp","name":"Zypern"},
    {"id":203,"alpha2":"cz","alpha3":"cze","name":"Tschechien"},

    {"id":208,"alpha2":"dk","alpha3":"dnk","name":"Dänemark"},
    {"id":262,"alpha2":"dj","alpha3":"dji","name":"Dschibuti"},
    {"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},
    {"id":214,"alpha2":"do","alpha3":"dom","name":"Dominikanische Republik"},

    {"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},
    {"id":818,"alpha2":"eg","alpha3":"egy","name":"Ägypten"},
    {"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},
    {"id":226,"alpha2":"gq","alpha3":"gnq","name":"Äquatorialguinea"},
    {"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},
    {"id":233,"alpha2":"ee","alpha3":"est","name":"Estland"},
    {"id":748,"alpha2":"sz","alpha3":"swz","name":"Eswatini"},
    {"id":231,"alpha2":"et","alpha3":"eth","name":"Äthiopien"},

    ...(includeEU ? [{"id":999,"alpha2":"eu","alpha3":"eur","name":"Europäische Union"}] : []),

    {"id":242,"alpha2":"fj","alpha3":"fji","name":"Fidschi"},
    {"id":234,"alpha2":"fo","alpha3":"fro","name":"Färöer-Inseln"},
    {"id":246,"alpha2":"fi","alpha3":"fin","name":"Finnland"},
    {"id":250,"alpha2":"fr","alpha3":"fra","name":"Frankreich"},

    {"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabun"},
    {"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},
    {"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgien"},
    {"id":276,"alpha2":"de","alpha3":"deu","name":"Deutschland"},
    {"id":276,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},
    {"id":304,"alpha2":"gl","alpha3":"grl","name":"Grönland"},
    {"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},
    {"id":300,"alpha2":"gr","alpha3":"grc","name":"Griechenland"},
    {"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},

    {"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},
    {"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},
    {"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bissau"},
    {"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},

    {"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},
    {"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},
    {"id":348,"alpha2":"hu","alpha3":"hun","name":"Ungarn"},

    {"id":352,"alpha2":"is","alpha3":"isl","name":"Island"},
    {"id":356,"alpha2":"in","alpha3":"ind","name":"Indien"},
    {"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesien"},
    {"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran (Islamische Republik)"},
    {"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},
    {"id":372,"alpha2":"ie","alpha3":"irl","name":"Irland"},
    {"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},
    {"id":380,"alpha2":"it","alpha3":"ita","name":"Italien"},

    {"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaika"},
    {"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japan"},
    {"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordanien"},

    {"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kasachstan"},
    {"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenia"},
    {"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},
    {"id":383,"alpha2":"xk","alpha3":"xkx","name":"Kosovo"},
    {"id":408,"alpha2":"kp","alpha3":"prk","name":"Korea (Demokratische Volksrepublik)"},
    {"id":410,"alpha2":"kr","alpha3":"kor","name":"Korea, Republik"},
    {"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},
    {"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirgisistan"},

    {"id":418,"alpha2":"la","alpha3":"lao","name":"Laos, Demokratische Volksrepublik"},
    {"id":428,"alpha2":"lv","alpha3":"lva","name":"Lettland"},
    {"id":422,"alpha2":"lb","alpha3":"lbn","name":"Libanon"},
    {"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},
    {"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},
    {"id":434,"alpha2":"ly","alpha3":"lby","name":"Libyen"},
    {"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},
    {"id":440,"alpha2":"lt","alpha3":"ltu","name":"Litauen"},
    {"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburg"},

    {"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagaskar"},
    {"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},
    {"id":458,"alpha2":"my","alpha3":"mys","name":"Malaysia"},
    {"id":462,"alpha2":"mv","alpha3":"mdv","name":"Malediven"},
    {"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},
    {"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},
    {"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshallinseln"},
    {"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauretanien"},
    {"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},
    {"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexiko"},
    {"id":583,"alpha2":"fm","alpha3":"fsm","name":"Mikronesien (Föderierte Staaten von)"},

    {"id":498,"alpha2":"md","alpha3":"mda","name":"Moldau, Republik"},
    {"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},
    {"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolei"},
    {"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},
    {"id":504,"alpha2":"ma","alpha3":"mar","name":"Marokko"},
    {"id":508,"alpha2":"mz","alpha3":"moz","name":"Mosambik"},

    {"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},
    {"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},
    {"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},
    {"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},
    {"id":528,"alpha2":"nl","alpha3":"nld","name":"Niederlande"},
    {"id":554,"alpha2":"nz","alpha3":"nzl","name":"Neuseeland"},
    {"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},
    {"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},
    {"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},
    {"id":807,"alpha2":"mk","alpha3":"mkd","name":"Nordmazedonien"},
    {"id":578,"alpha2":"no","alpha3":"nor","name":"Norwegen"},

    {"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},

    {"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},
    {"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},
    {"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},
    {"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},
    {"id":598,"alpha2":"pg","alpha3":"png","name":"Papua-Neuguinea"},
    {"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},
    {"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},
    {"id":608,"alpha2":"ph","alpha3":"phl","name":"Philippinen"},
    {"id":616,"alpha2":"pl","alpha3":"pol","name":"Polen"},
    {"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},

    {"id":634,"alpha2":"qa","alpha3":"qat","name":"Katar"},

    {"id":642,"alpha2":"ro","alpha3":"rou","name":"Rumänien"},
    {"id":643,"alpha2":"ru","alpha3":"rus","name":"Russische Föderation"},
    {"id":646,"alpha2":"rw","alpha3":"rwa","name":"Ruanda"},

    {"id":659,"alpha2":"kn","alpha3":"kna","name":"St. Kitts und Nevis"},
    {"id":662,"alpha2":"lc","alpha3":"lca","name":"St. Lucia"},
    {"id":670,"alpha2":"vc","alpha3":"vct","name":"St. Vincent und die Grenadinen"},
    {"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},
    {"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},
    {"id":678,"alpha2":"st","alpha3":"stp","name":"São Tomé und Príncipe"},
    {"id":682,"alpha2":"sa","alpha3":"sau","name":"Saudi-Arabien"},
    {"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},
    {"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbien"},
    {"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychellen"},
    {"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},
    {"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapur"},
    {"id":703,"alpha2":"sk","alpha3":"svk","name":"Slowakei"},
    {"id":705,"alpha2":"si","alpha3":"svn","name":"Slowenien"},

    {"id":90,"alpha2":"sb","alpha3":"slb","name":"Salomonen"},
    {"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},
    {"id":710,"alpha2":"za","alpha3":"zaf","name":"Südafrika"},
    {"id":728,"alpha2":"ss","alpha3":"ssd","name":"Südsudan"},
    {"id":724,"alpha2":"es","alpha3":"esp","name":"Spanien"},
    {"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},
    {"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudan"},
    {"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},
    {"id":752,"alpha2":"se","alpha3":"swe","name":"Schweden"},
    {"id":756,"alpha2":"ch","alpha3":"che","name":"Schweiz"},
    {"id":760,"alpha2":"sy","alpha3":"syr","name":"Syrien, Arabische Republik"},

    {"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadschikistan"},
    {"id":834,"alpha2":"tz","alpha3":"tza","name":"Tansania, Vereinigte Republik"},
    {"id":764,"alpha2":"th","alpha3":"tha","name":"Thailand"},
    {"id":626,"alpha2":"tl","alpha3":"tls","name":"Timor-Leste"},
    {"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},
    {"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},
    {"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad und Tobago"},
    {"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunesien"},
    {"id":792,"alpha2":"tr","alpha3":"tur","name":"Türkei"},
    {"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},
    {"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},

    {"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},
    {"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraine"},

    {"id":784,"alpha2":"ae","alpha3":"are","name":"Vereinigte Arabische Emirate"},
    {"id":826,"alpha2":"gb","alpha3":"gbr","name":"Vereinigtes Königreich"},
    {"id":840,"alpha2":"us","alpha3":"usa","name":"Vereinigte Staaten von Amerika"},

    {"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},
    {"id":860,"alpha2":"uz","alpha3":"uzb","name":"Usbekistan"},

    {"id":336,"alpha2":"va","alpha3":"vat","name":"Vatikanstadt"},
    {"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},
    {"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela (Bolivarische Republik)"},
    {"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},

    {"id":887,"alpha2":"ye","alpha3":"yem","name":"Jemen"},
    {"id":894,"alpha2":"zm","alpha3":"zmb","name":"Sambia"},
    {"id":716,"alpha2":"zw","alpha3":"zwe","name":"Simbabwe"},
    ];
};
const countryListFR = (includeEU = false) => {
    return [
    {"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},
    {"id":8,"alpha2":"al","alpha3":"alb","name":"Albanie"},
    {"id":12,"alpha2":"dz","alpha3":"dza","name":"Algérie"},
    {"id":20,"alpha2":"ad","alpha3":"and","name":"Andorre"},
    {"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},
    {"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua-et-Barbuda"},
    {"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentine"},
    {"id":51,"alpha2":"am","alpha3":"arm","name":"Arménie"},
    {"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},
    {"id":36,"alpha2":"au","alpha3":"aus","name":"Australie"},
    {"id":40,"alpha2":"at","alpha3":"aut","name":"Autriche"},
    {"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbaïdjan"},

    {"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},
    {"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahreïn"},
    {"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},
    {"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbade"},
    {"id":112,"alpha2":"by","alpha3":"blr","name":"Bélarus"},
    {"id":56,"alpha2":"be","alpha3":"bel","name":"Belgique"},
    {"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},
    {"id":204,"alpha2":"bj","alpha3":"ben","name":"Bénin"},
    {"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhoutan"},

    {"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivie (État plurinational de)"},
    {"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, Saint-Eustache et Saba"},
    {"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnie-Herzégovine"},

    {"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},
    {"id":76,"alpha2":"br","alpha3":"bra","name":"Brésil"},
    {"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunéi Darussalam"},
    {"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgarie"},
    {"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},
    {"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},

    {"id":132,"alpha2":"cv","alpha3":"cpv","name":"Cabo Verde"},
    {"id":116,"alpha2":"kh","alpha3":"khm","name":"Cambodge"},
    {"id":120,"alpha2":"cm","alpha3":"cmr","name":"Cameroun"},
    {"id":124,"alpha2":"ca","alpha3":"can","name":"Canada"},
    {"id":9001,"alpha2":"ic","alpha3":"ic","name":"Îles Canaries"},
    {"id":140,"alpha2":"cf","alpha3":"caf","name":"République centrafricaine"},
    {"id":148,"alpha2":"td","alpha3":"tcd","name":"Tchad"},
    {"id":152,"alpha2":"cl","alpha3":"chl","name":"Chili"},
    {"id":156,"alpha2":"cn","alpha3":"chn","name":"Chine"},
    {"id":170,"alpha2":"co","alpha3":"col","name":"Colombie"},
    {"id":174,"alpha2":"km","alpha3":"com","name":"Comores"},
    {"id":178,"alpha2":"cg","alpha3":"cog","name":"Congo"},
    {"id":180,"alpha2":"cd","alpha3":"cod","name":"Congo, République démocratique du"},
    {"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},
    {"id":384,"alpha2":"ci","alpha3":"civ","name":"Côte d'Ivoire"},
    {"id":191,"alpha2":"hr","alpha3":"hrv","name":"Croatie"},
    {"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},
    {"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},
    {"id":196,"alpha2":"cy","alpha3":"cyp","name":"Chypre"},
    {"id":203,"alpha2":"cz","alpha3":"cze","name":"Tchéquie"},

    {"id":208,"alpha2":"dk","alpha3":"dnk","name":"Danemark"},
    {"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},
    {"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominique"},
    {"id":214,"alpha2":"do","alpha3":"dom","name":"République dominicaine"},

    {"id":218,"alpha2":"ec","alpha3":"ecu","name":"Équateur"},
    {"id":818,"alpha2":"eg","alpha3":"egy","name":"Égypte"},
    {"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},
    {"id":226,"alpha2":"gq","alpha3":"gnq","name":"Guinée équatoriale"},
    {"id":232,"alpha2":"er","alpha3":"eri","name":"Érythrée"},
    {"id":233,"alpha2":"ee","alpha3":"est","name":"Estonie"},
    {"id":748,"alpha2":"sz","alpha3":"swz","name":"Eswatini"},
    {"id":231,"alpha2":"et","alpha3":"eth","name":"Éthiopie"},

    ...(includeEU ? [{"id":999,"alpha2":"eu","alpha3":"eur","name":"Union européenne"}] : []),

    {"id":242,"alpha2":"fj","alpha3":"fji","name":"Fidji"},
    {"id":234,"alpha2":"fo","alpha3":"fro","name":"Îles Féroé"},
    {"id":246,"alpha2":"fi","alpha3":"fin","name":"Finlande"},
    {"id":250,"alpha2":"fr","alpha3":"fra","name":"France"},

    {"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},
    {"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambie"},
    {"id":268,"alpha2":"ge","alpha3":"geo","name":"Géorgie"},
    {"id":276,"alpha2":"de","alpha3":"deu","name":"Allemagne"},
    {"id":276,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},
    {"id":304,"alpha2":"gl","alpha3":"grl","name":"Groenland"},
    {"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},
    {"id":300,"alpha2":"gr","alpha3":"grc","name":"Grèce"},
    {"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenade"},

    {"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},
    {"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinée"},
    {"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinée-Bissau"},
    {"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},

    {"id":332,"alpha2":"ht","alpha3":"hti","name":"Haïti"},
    {"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},
    {"id":348,"alpha2":"hu","alpha3":"hun","name":"Hongrie"},

    {"id":352,"alpha2":"is","alpha3":"isl","name":"Islande"},
    {"id":356,"alpha2":"in","alpha3":"ind","name":"Inde"},
    {"id":360,"alpha2":"id","alpha3":"idn","name":"Indonésie"},
    {"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran (République islamique d')"},
    {"id":368,"alpha2":"iq","alpha3":"irq","name":"Iraq"},
    {"id":372,"alpha2":"ie","alpha3":"irl","name":"Irlande"},
    {"id":376,"alpha2":"il","alpha3":"isr","name":"Israël"},
    {"id":380,"alpha2":"it","alpha3":"ita","name":"Italie"},

    {"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaïque"},
    {"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japon"},
    {"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordanie"},

    {"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazakhstan"},
    {"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenya"},
    {"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},
    {"id":383,"alpha2":"xk","alpha3":"xkx","name":"Kosovo"},
    {"id":408,"alpha2":"kp","alpha3":"prk","name":"Corée (République populaire démocratique de)"},
    {"id":410,"alpha2":"kr","alpha3":"kor","name":"Corée, République de"},
    {"id":414,"alpha2":"kw","alpha3":"kwt","name":"Koweït"},
    {"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirghizistan"},

    {"id":418,"alpha2":"la","alpha3":"lao","name":"Lao, République démocratique populaire"},
    {"id":428,"alpha2":"lv","alpha3":"lva","name":"Lettonie"},
    {"id":422,"alpha2":"lb","alpha3":"lbn","name":"Liban"},
    {"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},
    {"id":430,"alpha2":"lr","alpha3":"lbr","name":"Libéria"},
    {"id":434,"alpha2":"ly","alpha3":"lby","name":"Libye"},
    {"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},
    {"id":440,"alpha2":"lt","alpha3":"ltu","name":"Lituanie"},
    {"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxembourg"},

    {"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagascar"},
    {"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},
    {"id":458,"alpha2":"my","alpha3":"mys","name":"Malaisie"},
    {"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldives"},
    {"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},
    {"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malte"},
    {"id":584,"alpha2":"mh","alpha3":"mhl","name":"Îles Marshall"},
    {"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritanie"},
    {"id":480,"alpha2":"mu","alpha3":"mus","name":"Maurice"},
    {"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexique"},
    {"id":583,"alpha2":"fm","alpha3":"fsm","name":"Micronésie (États fédérés de)"},

    {"id":498,"alpha2":"md","alpha3":"mda","name":"Moldova, République de"},
    {"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},
    {"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolie"},
    {"id":499,"alpha2":"me","alpha3":"mne","name":"Monténégro"},
    {"id":504,"alpha2":"ma","alpha3":"mar","name":"Maroc"},
    {"id":508,"alpha2":"mz","alpha3":"moz","name":"Mozambique"},

    {"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},
    {"id":516,"alpha2":"na","alpha3":"nam","name":"Namibie"},
    {"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},
    {"id":524,"alpha2":"np","alpha3":"npl","name":"Népal"},
    {"id":528,"alpha2":"nl","alpha3":"nld","name":"Pays-Bas"},
    {"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nouvelle-Zélande"},
    {"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},
    {"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},
    {"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigéria"},
    {"id":807,"alpha2":"mk","alpha3":"mkd","name":"Macédoine du Nord"},
    {"id":578,"alpha2":"no","alpha3":"nor","name":"Norvège"},

    {"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},

    {"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},
    {"id":585,"alpha2":"pw","alpha3":"plw","name":"Palaos"},
    {"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},
    {"id":630,"alpha2":"pr","alpha3":"pri","name":"Porto Rico"},
    {"id":598,"alpha2":"pg","alpha3":"png","name":"Papouasie-Nouvelle-Guinée"},
    {"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},
    {"id":604,"alpha2":"pe","alpha3":"per","name":"Pérou"},
    {"id":608,"alpha2":"ph","alpha3":"phl","name":"Philippines"},
    {"id":616,"alpha2":"pl","alpha3":"pol","name":"Pologne"},
    {"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},

    {"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},

    {"id":642,"alpha2":"ro","alpha3":"rou","name":"Roumanie"},
    {"id":643,"alpha2":"ru","alpha3":"rus","name":"Fédération de Russie"},
    {"id":646,"alpha2":"rw","alpha3":"rwa","name":"Rwanda"},

    {"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint-Kitts-et-Nevis"},
    {"id":662,"alpha2":"lc","alpha3":"lca","name":"Sainte-Lucie"},
    {"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint-Vincent-et-les-Grenadines"},
    {"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},
    {"id":674,"alpha2":"sm","alpha3":"smr","name":"Saint-Marin"},
    {"id":678,"alpha2":"st","alpha3":"stp","name":"Sao Tomé-et-Principe"},
    {"id":682,"alpha2":"sa","alpha3":"sau","name":"Arabie saoudite"},
    {"id":686,"alpha2":"sn","alpha3":"sen","name":"Sénégal"},
    {"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbie"},
    {"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychelles"},
    {"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},
    {"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapour"},
    {"id":703,"alpha2":"sk","alpha3":"svk","name":"Slovaquie"},
    {"id":705,"alpha2":"si","alpha3":"svn","name":"Slovénie"},

    {"id":90,"alpha2":"sb","alpha3":"slb","name":"Îles Salomon"},
    {"id":706,"alpha2":"so","alpha3":"som","name":"Somalie"},
    {"id":710,"alpha2":"za","alpha3":"zaf","name":"Afrique du Sud"},
    {"id":728,"alpha2":"ss","alpha3":"ssd","name":"Soudan du Sud"},
    {"id":724,"alpha2":"es","alpha3":"esp","name":"Espagne"},
    {"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},
    {"id":729,"alpha2":"sd","alpha3":"sdn","name":"Soudan"},
    {"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},
    {"id":752,"alpha2":"se","alpha3":"swe","name":"Suède"},
    {"id":756,"alpha2":"ch","alpha3":"che","name":"Suisse"},
    {"id":760,"alpha2":"sy","alpha3":"syr","name":"République arabe syrienne"},

    {"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadjikistan"},
    {"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzanie, République-Unie de"},
    {"id":764,"alpha2":"th","alpha3":"tha","name":"Thaïlande"},
    {"id":626,"alpha2":"tl","alpha3":"tls","name":"Timor-Leste"},
    {"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},
    {"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},
    {"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinité-et-Tobago"},
    {"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunisie"},
    {"id":792,"alpha2":"tr","alpha3":"tur","name":"Turquie"},
    {"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkménistan"},
    {"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},

    {"id":800,"alpha2":"ug","alpha3":"uga","name":"Ouganda"},
    {"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraine"},

    {"id":784,"alpha2":"ae","alpha3":"are","name":"Émirats arabes unis"},
    {"id":826,"alpha2":"gb","alpha3":"gbr","name":"Royaume-Uni"},
    {"id":840,"alpha2":"us","alpha3":"usa","name":"États-Unis d'Amérique"},

    {"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},
    {"id":860,"alpha2":"uz","alpha3":"uzb","name":"Ouzbékistan"},

    {"id":336,"alpha2":"va","alpha3":"vat","name":"Cité du Vatican"},
    {"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},
    {"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela (République bolivarienne du)"},
    {"id":704,"alpha2":"vn","alpha3":"vnm","name":"Viet Nam"},

    {"id":887,"alpha2":"ye","alpha3":"yem","name":"Yémen"},
    {"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambie"},
    {"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"},
    ];
};
const countryListES = (includeEU = false) => {
    return [
    {"id":4,"alpha2":"af","alpha3":"afg","name":"Afganistán"},
    {"id":8,"alpha2":"al","alpha3":"alb","name":"Albania"},
    {"id":12,"alpha2":"dz","alpha3":"dza","name":"Argelia"},
    {"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},
    {"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},
    {"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua y Barbuda"},
    {"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},
    {"id":51,"alpha2":"am","alpha3":"arm","name":"Armenia"},
    {"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},
    {"id":36,"alpha2":"au","alpha3":"aus","name":"Australia"},
    {"id":40,"alpha2":"at","alpha3":"aut","name":"Austria"},
    {"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbaiyán"},

    {"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},
    {"id":48,"alpha2":"bh","alpha3":"bhr","name":"Baréin"},
    {"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladés"},
    {"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},
    {"id":112,"alpha2":"by","alpha3":"blr","name":"Bielorrusia"},
    {"id":56,"alpha2":"be","alpha3":"bel","name":"Bélgica"},
    {"id":84,"alpha2":"bz","alpha3":"blz","name":"Belice"},
    {"id":204,"alpha2":"bj","alpha3":"ben","name":"Benín"},
    {"id":64,"alpha2":"bt","alpha3":"btn","name":"Bután"},

    {"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia (Estado Plurinacional de)"},
    {"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, San Eustaquio y Saba"},
    {"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnia y Herzegovina"},

    {"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botsuana"},
    {"id":76,"alpha2":"br","alpha3":"bra","name":"Brasil"},
    {"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunéi Darussalam"},
    {"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgaria"},
    {"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},
    {"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},

    {"id":132,"alpha2":"cv","alpha3":"cpv","name":"Cabo Verde"},
    {"id":116,"alpha2":"kh","alpha3":"khm","name":"Camboya"},
    {"id":120,"alpha2":"cm","alpha3":"cmr","name":"Camerún"},
    {"id":124,"alpha2":"ca","alpha3":"can","name":"Canadá"},
    {"id":9001,"alpha2":"ic","alpha3":"ic","name":"Islas Canarias"},
    {"id":140,"alpha2":"cf","alpha3":"caf","name":"República Centroafricana"},
    {"id":148,"alpha2":"td","alpha3":"tcd","name":"Chad"},
    {"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},
    {"id":156,"alpha2":"cn","alpha3":"chn","name":"China"},
    {"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},
    {"id":174,"alpha2":"km","alpha3":"com","name":"Comoras"},
    {"id":178,"alpha2":"cg","alpha3":"cog","name":"Congo"},
    {"id":180,"alpha2":"cd","alpha3":"cod","name":"Congo, República Democrática del"},
    {"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},
    {"id":384,"alpha2":"ci","alpha3":"civ","name":"Costa de Marfil"},
    {"id":191,"alpha2":"hr","alpha3":"hrv","name":"Croacia"},
    {"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},
    {"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curazao"},
    {"id":196,"alpha2":"cy","alpha3":"cyp","name":"Chipre"},
    {"id":203,"alpha2":"cz","alpha3":"cze","name":"Chequia"},

    {"id":208,"alpha2":"dk","alpha3":"dnk","name":"Dinamarca"},
    {"id":262,"alpha2":"dj","alpha3":"dji","name":"Yibuti"},
    {"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},
    {"id":214,"alpha2":"do","alpha3":"dom","name":"República Dominicana"},

    {"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},
    {"id":818,"alpha2":"eg","alpha3":"egy","name":"Egipto"},
    {"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},
    {"id":226,"alpha2":"gq","alpha3":"gnq","name":"Guinea Ecuatorial"},
    {"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},
    {"id":233,"alpha2":"ee","alpha3":"est","name":"Estonia"},
    {"id":748,"alpha2":"sz","alpha3":"swz","name":"Esuatini"},
    {"id":231,"alpha2":"et","alpha3":"eth","name":"Etiopía"},

    ...(includeEU ? [{"id":999,"alpha2":"eu","alpha3":"eur","name":"Unión Europea"}] : []),

    {"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiyi"},
    {"id":234,"alpha2":"fo","alpha3":"fro","name":"Islas Feroe"},
    {"id":246,"alpha2":"fi","alpha3":"fin","name":"Finlandia"},
    {"id":250,"alpha2":"fr","alpha3":"fra","name":"Francia"},

    {"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabón"},
    {"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},
    {"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgia"},
    {"id":276,"alpha2":"de","alpha3":"deu","name":"Alemania"},
    {"id":276,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},
    {"id":304,"alpha2":"gl","alpha3":"grl","name":"Groenlandia"},
    {"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},
    {"id":300,"alpha2":"gr","alpha3":"grc","name":"Grecia"},
    {"id":308,"alpha2":"gd","alpha3":"grd","name":"Granada"},

    {"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},
    {"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},
    {"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bisáu"},
    {"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},

    {"id":332,"alpha2":"ht","alpha3":"hti","name":"Haití"},
    {"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},
    {"id":348,"alpha2":"hu","alpha3":"hun","name":"Hungría"},

    {"id":352,"alpha2":"is","alpha3":"isl","name":"Islandia"},
    {"id":356,"alpha2":"in","alpha3":"ind","name":"India"},
    {"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesia"},
    {"id":364,"alpha2":"ir","alpha3":"irn","name":"Irán (República Islámica de)"},
    {"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},
    {"id":372,"alpha2":"ie","alpha3":"irl","name":"Irlanda"},
    {"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},
    {"id":380,"alpha2":"it","alpha3":"ita","name":"Italia"},

    {"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},
    {"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japón"},
    {"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordania"},

    {"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazajistán"},
    {"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenia"},
    {"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},
    {"id":383,"alpha2":"xk","alpha3":"xkx","name":"Kosovo"},
    {"id":408,"alpha2":"kp","alpha3":"prk","name":"Corea (República Popular Democrática de)"},
    {"id":410,"alpha2":"kr","alpha3":"kor","name":"Corea, República de"},
    {"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},
    {"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirguistán"},

    {"id":418,"alpha2":"la","alpha3":"lao","name":"Lao, República Democrática Popular"},
    {"id":428,"alpha2":"lv","alpha3":"lva","name":"Letonia"},
    {"id":422,"alpha2":"lb","alpha3":"lbn","name":"Líbano"},
    {"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesoto"},
    {"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},
    {"id":434,"alpha2":"ly","alpha3":"lby","name":"Libia"},
    {"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},
    {"id":440,"alpha2":"lt","alpha3":"ltu","name":"Lituania"},
    {"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburgo"},

    {"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagascar"},
    {"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malaui"},
    {"id":458,"alpha2":"my","alpha3":"mys","name":"Malasia"},
    {"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldivas"},
    {"id":466,"alpha2":"ml","alpha3":"mli","name":"Malí"},
    {"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},
    {"id":584,"alpha2":"mh","alpha3":"mhl","name":"Islas Marshall"},
    {"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritania"},
    {"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauricio"},
    {"id":484,"alpha2":"mx","alpha3":"mex","name":"México"},
    {"id":583,"alpha2":"fm","alpha3":"fsm","name":"Micronesia (Estados Federados de)"},

    {"id":498,"alpha2":"md","alpha3":"mda","name":"Moldavia, República de"},
    {"id":492,"alpha2":"mc","alpha3":"mco","name":"Mónaco"},
    {"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolia"},
    {"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},
    {"id":504,"alpha2":"ma","alpha3":"mar","name":"Marruecos"},
    {"id":508,"alpha2":"mz","alpha3":"moz","name":"Mozambique"},

    {"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},
    {"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},
    {"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},
    {"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},
    {"id":528,"alpha2":"nl","alpha3":"nld","name":"Países Bajos"},
    {"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nueva Zelanda"},
    {"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},
    {"id":562,"alpha2":"ne","alpha3":"ner","name":"Níger"},
    {"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},
    {"id":807,"alpha2":"mk","alpha3":"mkd","name":"Macedonia del Norte"},
    {"id":578,"alpha2":"no","alpha3":"nor","name":"Noruega"},

    {"id":512,"alpha2":"om","alpha3":"omn","name":"Omán"},

    {"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistán"},
    {"id":585,"alpha2":"pw","alpha3":"plw","name":"Palaos"},
    {"id":591,"alpha2":"pa","alpha3":"pan","name":"Panamá"},
    {"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},
    {"id":598,"alpha2":"pg","alpha3":"png","name":"Papúa Nueva Guinea"},
    {"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},
    {"id":604,"alpha2":"pe","alpha3":"per","name":"Perú"},
    {"id":608,"alpha2":"ph","alpha3":"phl","name":"Filipinas"},
    {"id":616,"alpha2":"pl","alpha3":"pol","name":"Polonia"},
    {"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},

    {"id":634,"alpha2":"qa","alpha3":"qat","name":"Catar"},

    {"id":642,"alpha2":"ro","alpha3":"rou","name":"Rumanía"},
    {"id":643,"alpha2":"ru","alpha3":"rus","name":"Federación de Rusia"},
    {"id":646,"alpha2":"rw","alpha3":"rwa","name":"Ruanda"},

    {"id":659,"alpha2":"kn","alpha3":"kna","name":"San Cristóbal y Nieves"},
    {"id":662,"alpha2":"lc","alpha3":"lca","name":"Santa Lucía"},
    {"id":670,"alpha2":"vc","alpha3":"vct","name":"San Vicente y las Granadinas"},
    {"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},
    {"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},
    {"id":678,"alpha2":"st","alpha3":"stp","name":"Santo Tomé y Príncipe"},
    {"id":682,"alpha2":"sa","alpha3":"sau","name":"Arabia Saudita"},
    {"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},
    {"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbia"},
    {"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychelles"},
    {"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leona"},
    {"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapur"},
    {"id":703,"alpha2":"sk","alpha3":"svk","name":"Eslovaquia"},
    {"id":705,"alpha2":"si","alpha3":"svn","name":"Eslovenia"},

    {"id":90,"alpha2":"sb","alpha3":"slb","name":"Islas Salomón"},
    {"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},
    {"id":710,"alpha2":"za","alpha3":"zaf","name":"Sudáfrica"},
    {"id":728,"alpha2":"ss","alpha3":"ssd","name":"Sudán del Sur"},
    {"id":724,"alpha2":"es","alpha3":"esp","name":"España"},
    {"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},
    {"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudán"},
    {"id":740,"alpha2":"sr","alpha3":"sur","name":"Surinam"},
    {"id":752,"alpha2":"se","alpha3":"swe","name":"Suecia"},
    {"id":756,"alpha2":"ch","alpha3":"che","name":"Suiza"},
    {"id":760,"alpha2":"sy","alpha3":"syr","name":"República Árabe Siria"},

    {"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tayikistán"},
    {"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania, República Unida de"},
    {"id":764,"alpha2":"th","alpha3":"tha","name":"Tailandia"},
    {"id":626,"alpha2":"tl","alpha3":"tls","name":"Timor Oriental"},
    {"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},
    {"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},
    {"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad y Tobago"},
    {"id":788,"alpha2":"tn","alpha3":"tun","name":"Túnez"},
    {"id":792,"alpha2":"tr","alpha3":"tur","name":"Turquía"},
    {"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistán"},
    {"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},

    {"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},
    {"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ucrania"},

    {"id":784,"alpha2":"ae","alpha3":"are","name":"Emiratos Árabes Unidos"},
    {"id":826,"alpha2":"gb","alpha3":"gbr","name":"Reino Unido"},
    {"id":840,"alpha2":"us","alpha3":"usa","name":"Estados Unidos de América"},

    {"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},
    {"id":860,"alpha2":"uz","alpha3":"uzb","name":"Uzbekistán"},

    {"id":336,"alpha2":"va","alpha3":"vat","name":"Ciudad del Vaticano"},
    {"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},
    {"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela (República Bolivariana de)"},
    {"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},

    {"id":887,"alpha2":"ye","alpha3":"yem","name":"Yemen"},
    {"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},
    {"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabue"},
    ];
};
const countryListPT = (includeEU = false) => {
    return [
    {"id":4,"alpha2":"af","alpha3":"afg","name":"Afeganistão"},
    {"id":8,"alpha2":"al","alpha3":"alb","name":"Albânia"},
    {"id":12,"alpha2":"dz","alpha3":"dza","name":"Argélia"},
    {"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},
    {"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},
    {"id":28,"alpha2":"ag","alpha3":"atg","name":"Antígua e Barbuda"},
    {"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},
    {"id":51,"alpha2":"am","alpha3":"arm","name":"Arménia"},
    {"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},
    {"id":36,"alpha2":"au","alpha3":"aus","name":"Austrália"},
    {"id":40,"alpha2":"at","alpha3":"aut","name":"Áustria"},
    {"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbaijão"},

    {"id":44,"alpha2":"bs","alpha3":"bhs","name":"Baamas"},
    {"id":48,"alpha2":"bh","alpha3":"bhr","name":"Barém"},
    {"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladeche"},
    {"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},
    {"id":112,"alpha2":"by","alpha3":"blr","name":"Bielorrússia"},
    {"id":56,"alpha2":"be","alpha3":"bel","name":"Bélgica"},
    {"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},
    {"id":204,"alpha2":"bj","alpha3":"ben","name":"Benim"},
    {"id":64,"alpha2":"bt","alpha3":"btn","name":"Butão"},

    {"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolívia (Estado Plurinacional da)"},
    {"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, Santo Eustáquio e Saba"},
    {"id":70,"alpha2":"ba","alpha3":"bih","name":"Bósnia e Herzegovina"},

    {"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botsuana"},
    {"id":76,"alpha2":"br","alpha3":"bra","name":"Brasil"},
    {"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei Darussalam"},
    {"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgária"},
    {"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burquina Faso"},
    {"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},

    {"id":132,"alpha2":"cv","alpha3":"cpv","name":"Cabo Verde"},
    {"id":116,"alpha2":"kh","alpha3":"khm","name":"Camboja"},
    {"id":120,"alpha2":"cm","alpha3":"cmr","name":"Camarões"},
    {"id":124,"alpha2":"ca","alpha3":"can","name":"Canadá"},
    {"id":9001,"alpha2":"ic","alpha3":"ic","name":"Ilhas Canárias"},
    {"id":140,"alpha2":"cf","alpha3":"caf","name":"República Centro-Africana"},
    {"id":148,"alpha2":"td","alpha3":"tcd","name":"Chade"},
    {"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},
    {"id":156,"alpha2":"cn","alpha3":"chn","name":"China"},
    {"id":170,"alpha2":"co","alpha3":"col","name":"Colômbia"},
    {"id":174,"alpha2":"km","alpha3":"com","name":"Comores"},
    {"id":178,"alpha2":"cg","alpha3":"cog","name":"Congo"},
    {"id":180,"alpha2":"cd","alpha3":"cod","name":"Congo, República Democrática do"},
    {"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},
    {"id":384,"alpha2":"ci","alpha3":"civ","name":"Costa do Marfim"},
    {"id":191,"alpha2":"hr","alpha3":"hrv","name":"Croácia"},
    {"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},
    {"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçau"},
    {"id":196,"alpha2":"cy","alpha3":"cyp","name":"Chipre"},
    {"id":203,"alpha2":"cz","alpha3":"cze","name":"Chéquia"},

    {"id":208,"alpha2":"dk","alpha3":"dnk","name":"Dinamarca"},
    {"id":262,"alpha2":"dj","alpha3":"dji","name":"Jibuti"},
    {"id":212,"alpha2":"dm","alpha3":"dma","name":"Domínica"},
    {"id":214,"alpha2":"do","alpha3":"dom","name":"República Dominicana"},

    {"id":218,"alpha2":"ec","alpha3":"ecu","name":"Equador"},
    {"id":818,"alpha2":"eg","alpha3":"egy","name":"Egito"},
    {"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},
    {"id":226,"alpha2":"gq","alpha3":"gnq","name":"Guiné Equatorial"},
    {"id":232,"alpha2":"er","alpha3":"eri","name":"Eritreia"},
    {"id":233,"alpha2":"ee","alpha3":"est","name":"Estónia"},
    {"id":748,"alpha2":"sz","alpha3":"swz","name":"Essuatíni"},
    {"id":231,"alpha2":"et","alpha3":"eth","name":"Etiópia"},

    ...(includeEU ? [{"id":999,"alpha2":"eu","alpha3":"eur","name":"União Europeia"}] : []),

    {"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiji"},
    {"id":234,"alpha2":"fo","alpha3":"fro","name":"Ilhas Faroé"},
    {"id":246,"alpha2":"fi","alpha3":"fin","name":"Finlândia"},
    {"id":250,"alpha2":"fr","alpha3":"fra","name":"França"},

    {"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabão"},
    {"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gâmbia"},
    {"id":268,"alpha2":"ge","alpha3":"geo","name":"Geórgia"},
    {"id":276,"alpha2":"de","alpha3":"deu","name":"Alemanha"},
    {"id":276,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},
    {"id":304,"alpha2":"gl","alpha3":"grl","name":"Gronelândia"},
    {"id":288,"alpha2":"gh","alpha3":"gha","name":"Gana"},
    {"id":300,"alpha2":"gr","alpha3":"grc","name":"Grécia"},
    {"id":308,"alpha2":"gd","alpha3":"grd","name":"Granada"},

    {"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},
    {"id":324,"alpha2":"gn","alpha3":"gin","name":"Guiné"},
    {"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guiné-Bissau"},
    {"id":328,"alpha2":"gy","alpha3":"guy","name":"Guiana"},

    {"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},
    {"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},
    {"id":348,"alpha2":"hu","alpha3":"hun","name":"Hungria"},

    {"id":352,"alpha2":"is","alpha3":"isl","name":"Islândia"},
    {"id":356,"alpha2":"in","alpha3":"ind","name":"Índia"},
    {"id":360,"alpha2":"id","alpha3":"idn","name":"Indonésia"},
    {"id":364,"alpha2":"ir","alpha3":"irn","name":"Irão (República Islâmica do)"},
    {"id":368,"alpha2":"iq","alpha3":"irq","name":"Iraque"},
    {"id":372,"alpha2":"ie","alpha3":"irl","name":"Irlanda"},
    {"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},
    {"id":380,"alpha2":"it","alpha3":"ita","name":"Itália"},

    {"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},
    {"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japão"},
    {"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordânia"},

    {"id":398,"alpha2":"kz","alpha3":"kaz","name":"Cazaquistão"},
    {"id":404,"alpha2":"ke","alpha3":"ken","name":"Quénia"},
    {"id":296,"alpha2":"ki","alpha3":"kir","name":"Quiribáti"},
    {"id":383,"alpha2":"xk","alpha3":"xkx","name":"Kosovo"},
    {"id":408,"alpha2":"kp","alpha3":"prk","name":"Coreia (República Popular Democrática da)"},
    {"id":410,"alpha2":"kr","alpha3":"kor","name":"Coreia, República da"},
    {"id":414,"alpha2":"kw","alpha3":"kwt","name":"Koweit"},
    {"id":417,"alpha2":"kg","alpha3":"kgz","name":"Quirguistão"},

    {"id":418,"alpha2":"la","alpha3":"lao","name":"Laos, República Democrática Popular do"},
    {"id":428,"alpha2":"lv","alpha3":"lva","name":"Letónia"},
    {"id":422,"alpha2":"lb","alpha3":"lbn","name":"Líbano"},
    {"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesoto"},
    {"id":430,"alpha2":"lr","alpha3":"lbr","name":"Libéria"},
    {"id":434,"alpha2":"ly","alpha3":"lby","name":"Líbia"},
    {"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},
    {"id":440,"alpha2":"lt","alpha3":"ltu","name":"Lituânia"},
    {"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburgo"},

    {"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagáscar"},
    {"id":454,"alpha2":"mw","alpha3":"mwi","name":"Maláui"},
    {"id":458,"alpha2":"my","alpha3":"mys","name":"Malásia"},
    {"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldivas"},
    {"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},
    {"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},
    {"id":584,"alpha2":"mh","alpha3":"mhl","name":"Ilhas Marshall"},
    {"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritânia"},
    {"id":480,"alpha2":"mu","alpha3":"mus","name":"Maurícia"},
    {"id":484,"alpha2":"mx","alpha3":"mex","name":"México"},
    {"id":583,"alpha2":"fm","alpha3":"fsm","name":"Micronésia (Estados Federados da)"},

    {"id":498,"alpha2":"md","alpha3":"mda","name":"Moldávia, República da"},
    {"id":492,"alpha2":"mc","alpha3":"mco","name":"Mónaco"},
    {"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongólia"},
    {"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},
    {"id":504,"alpha2":"ma","alpha3":"mar","name":"Marrocos"},
    {"id":508,"alpha2":"mz","alpha3":"moz","name":"Moçambique"},

    {"id":104,"alpha2":"mm","alpha3":"mmr","name":"Mianmar"},
    {"id":516,"alpha2":"na","alpha3":"nam","name":"Namíbia"},
    {"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},
    {"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},
    {"id":528,"alpha2":"nl","alpha3":"nld","name":"Países Baixos"},
    {"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nova Zelândia"},
    {"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicarágua"},
    {"id":562,"alpha2":"ne","alpha3":"ner","name":"Níger"},
    {"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigéria"},
    {"id":807,"alpha2":"mk","alpha3":"mkd","name":"Macedónia do Norte"},
    {"id":578,"alpha2":"no","alpha3":"nor","name":"Noruega"},

    {"id":512,"alpha2":"om","alpha3":"omn","name":"Omã"},

    {"id":586,"alpha2":"pk","alpha3":"pak","name":"Paquistão"},
    {"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},
    {"id":591,"alpha2":"pa","alpha3":"pan","name":"Panamá"},
    {"id":630,"alpha2":"pr","alpha3":"pri","name":"Porto Rico"},
    {"id":598,"alpha2":"pg","alpha3":"png","name":"Papua-Nova Guiné"},
    {"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguai"},
    {"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},
    {"id":608,"alpha2":"ph","alpha3":"phl","name":"Filipinas"},
    {"id":616,"alpha2":"pl","alpha3":"pol","name":"Polónia"},
    {"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},

    {"id":634,"alpha2":"qa","alpha3":"qat","name":"Catar"},

    {"id":642,"alpha2":"ro","alpha3":"rou","name":"Roménia"},
    {"id":643,"alpha2":"ru","alpha3":"rus","name":"Federação da Rússia"},
    {"id":646,"alpha2":"rw","alpha3":"rwa","name":"Ruanda"},

    {"id":659,"alpha2":"kn","alpha3":"kna","name":"São Cristóvão e Neves"},
    {"id":662,"alpha2":"lc","alpha3":"lca","name":"Santa Lúcia"},
    {"id":670,"alpha2":"vc","alpha3":"vct","name":"São Vicente e Granadinas"},
    {"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},
    {"id":674,"alpha2":"sm","alpha3":"smr","name":"São Marinho"},
    {"id":678,"alpha2":"st","alpha3":"stp","name":"São Tomé e Príncipe"},
    {"id":682,"alpha2":"sa","alpha3":"sau","name":"Arábia Saudita"},
    {"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},
    {"id":688,"alpha2":"rs","alpha3":"srb","name":"Sérvia"},
    {"id":690,"alpha2":"sc","alpha3":"syc","name":"Seicheles"},
    {"id":694,"alpha2":"sl","alpha3":"sle","name":"Serra Leoa"},
    {"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapura"},
    {"id":703,"alpha2":"sk","alpha3":"svk","name":"Eslováquia"},
    {"id":705,"alpha2":"si","alpha3":"svn","name":"Eslovénia"},

    {"id":90,"alpha2":"sb","alpha3":"slb","name":"Ilhas Salomão"},
    {"id":706,"alpha2":"so","alpha3":"som","name":"Somália"},
    {"id":710,"alpha2":"za","alpha3":"zaf","name":"África do Sul"},
    {"id":728,"alpha2":"ss","alpha3":"ssd","name":"Sudão do Sul"},
    {"id":724,"alpha2":"es","alpha3":"esp","name":"Espanha"},
    {"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanca"},
    {"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudão"},
    {"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},
    {"id":752,"alpha2":"se","alpha3":"swe","name":"Suécia"},
    {"id":756,"alpha2":"ch","alpha3":"che","name":"Suíça"},
    {"id":760,"alpha2":"sy","alpha3":"syr","name":"República Árabe Síria"},

    {"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tajiquistão"},
    {"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzânia, República Unida da"},
    {"id":764,"alpha2":"th","alpha3":"tha","name":"Tailândia"},
    {"id":626,"alpha2":"tl","alpha3":"tls","name":"Timor-Leste"},
    {"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},
    {"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},
    {"id":780,"alpha2":"tt","alpha3":"tto","name":"Trindade e Tobago"},
    {"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunísia"},
    {"id":792,"alpha2":"tr","alpha3":"tur","name":"Turquia"},
    {"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turquemenistão"},
    {"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},

    {"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},
    {"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ucrânia"},

    {"id":784,"alpha2":"ae","alpha3":"are","name":"Emirados Árabes Unidos"},
    {"id":826,"alpha2":"gb","alpha3":"gbr","name":"Reino Unido"},
    {"id":840,"alpha2":"us","alpha3":"usa","name":"Estados Unidos da América"},

    {"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguai"},
    {"id":860,"alpha2":"uz","alpha3":"uzb","name":"Usbequistão"},

    {"id":336,"alpha2":"va","alpha3":"vat","name":"Cidade do Vaticano"},
    {"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},
    {"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela (República Bolivariana da)"},
    {"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietname"},

    {"id":887,"alpha2":"ye","alpha3":"yem","name":"Iémen"},
    {"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zâmbia"},
    {"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabué"},
    ];
};
// Every alpha2 code known across all locale lists, used as the "Worldwide" set.
const allCountryCodes = [
    ...new Set([
        ...countryListEN(false).map(c => c.alpha2),
        ...countryListNL(false).map(c => c.alpha2),
        ...countryListDE(false).map(c => c.alpha2),
        ...countryListFR(false).map(c => c.alpha2),
        ...countryListES(false).map(c => c.alpha2),
        ...countryListPT(false).map(c => c.alpha2),
    ])
];

export const regions = [
    {
        id:7,
        name:"Wereldwijd",
        countries:allCountryCodes
    },
    {
        id:0,
        name:"Europa",
        countries:[
            "ad","al","at","be","ba","bg","hr","cy","cz","dk","ee","fi","fr",
            "de","gr","hu","is","ie","it","lv","lt","lu","mt","nl","no","pl",
            "pt","ro","rs","sk","si","es","se","ch","ua","me","mk","gb","by",
            "md","li","mc","sm","va","ru","xk"
        ]
    },
    // {
    //     id:1,
    //     name:"Afrika",
    //     countries:[
    //         "dz","ao","bj","bw","bf","bi","cm","cv","cf","td","km","cg","cd",
    //         "dj","eg","gq","er","et","ga","gm","gh","gn","gw","ci","ke","ls",
    //         "lr","ly","mg","mw","ml","mr","mu","ma","mz","na","ne","ng","rw",
    //         "st","sn","sc","sl","so","za","ss","sd","sz","tz","tg","tn","ug",
    //         "zm","zw"
    //     ]
    // },
    // {
    //     id:2,
    //     name:"Noord Amerika",
    //     countries:[
    //         "ca","us","mx","bz","cr","cu","do","gt","ht","hn","jm","ni","pa","sv"
    //     ]
    // },
    // {
    //     id:3,
    //     name:"Zuid amerika",
    //     countries: [
    //         "ar","bo","br","cl","co","ec","gy","py","pe","sr","uy","ve"
    //     ]
    // },
    // {
    //     id:4,
    //     name:"Azië",
    //     countries: [
    //         "af","am","az","bh","bd","bt","bn","kh","cn","ge","in","id","ir","iq",
    //         "il","jp","jo","kz","kw","kg","la","lb","my","mv","mn","mm","np","kp",
    //         "om","pk","ps","ph","qa","sa","sg","kr","lk","sy","tj","th","tl","tr",
    //         "tm","ae","uz","vn","ye"
    //     ]
    // },
    // {
    //     id:5,
    //     name:"Oceanië",
    //     countries: [
    //         "au","fj","ki","mh","fm","nr","nz","pw","pg","sb","ws","to","tv","vu"
    //     ]
    // },
    {
        id:6,
        name:"Europese unie",
        countries:[
            "at","be","bg","hr","cy","cz","dk","ee","fi","fr","de","gr","hu","ie",
            "it","lv","lt","lu","mt","nl","pl","pt","ro","sk","si","es","se"
        ]
    }
];
export const quickSelect = [
    { 
        id:0,
        name:"Nederland",
        countries:[
            "nl",
        ]
    },
    { 
        id:1,
        name:"Duitsland",
        countries:[
            "de",
        ]
    },
    { 
        id:2,
        name:"Benelux",
        countries:[
            "lu", "nl", "be"
        ]
    },
    { 
        id:3,
        name:"Europa",
        countries:[
            "ad","al","at","be","ba","bg","hr","cy","cz","dk","ee","fi","fr",
            "de","gr","hu","is","ie","it","lv","lt","lu","mt","nl","no","pl",
            "pt","ro","rs","sk","si","es","se","ch","ua","me","mk","gb","by",
            "md","li","mc","sm","va","ru","xk"
        ]
    },
    {
        id:4,
        name:"Europese unie",
        countries:[
            "at","be","bg","hr","cy","cz","dk","ee","fi","fr","de","gr","hu","ie",
            "it","lv","lt","lu","mt","nl","pl","pt","ro","sk","si","es","se"
        ]
    }
];
const countryListSV = (includeEU = false) => {
    return [
    {"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},
    {"id":8,"alpha2":"al","alpha3":"alb","name":"Albanien"},
    {"id":12,"alpha2":"dz","alpha3":"dza","name":"Algeriet"},
    {"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},
    {"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},
    {"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua och Barbuda"},
    {"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},
    {"id":51,"alpha2":"am","alpha3":"arm","name":"Armenien"},
    {"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},
    {"id":36,"alpha2":"au","alpha3":"aus","name":"Australien"},
    {"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbajdzjan"},
    {"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},
    {"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrain"},
    {"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},
    {"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},
    {"id":112,"alpha2":"by","alpha3":"blr","name":"Belarus"},
    {"id":56,"alpha2":"be","alpha3":"bel","name":"Belgien"},
    {"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},
    {"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},
    {"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},
    {"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia"},
    {"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, Sint Eustatius och Saba"},
    {"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnien och Hercegovina"},
    {"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},
    {"id":76,"alpha2":"br","alpha3":"bra","name":"Brasilien"},
    {"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},
    {"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgarien"},
    {"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},
    {"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},
    {"id":140,"alpha2":"cf","alpha3":"caf","name":"Centralafrikanska republiken"},
    {"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},
    {"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},
    {"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},
    {"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},
    {"id":196,"alpha2":"cy","alpha3":"cyp","name":"Cypern"},
    {"id":208,"alpha2":"dk","alpha3":"dnk","name":"Danmark"},
    {"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},
    {"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},
    {"id":214,"alpha2":"do","alpha3":"dom","name":"Dominikanska republiken"},
    {"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},
    {"id":818,"alpha2":"eg","alpha3":"egy","name":"Egypten"},
    {"id":226,"alpha2":"gq","alpha3":"gnq","name":"Ekvatorialguinea"},
    {"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},
    {"id":384,"alpha2":"ci","alpha3":"civ","name":"Elfenbenskusten"},
    {"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},
    {"id":233,"alpha2":"ee","alpha3":"est","name":"Estland"},
    {"id":748,"alpha2":"sz","alpha3":"swz","name":"Eswatini"},
    {"id":231,"alpha2":"et","alpha3":"eth","name":"Etiopien"},
    ...(includeEU ? [{"id":999,"alpha2":"eu","alpha3":"eur","name":"Europeiska unionen"}] : []),
    {"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiji"},
    {"id":608,"alpha2":"ph","alpha3":"phl","name":"Filippinerna"},
    {"id":246,"alpha2":"fi","alpha3":"fin","name":"Finland"},
    {"id":250,"alpha2":"fr","alpha3":"fra","name":"Frankrike"},
    {"id":234,"alpha2":"fo","alpha3":"fro","name":"Färöarna"},
    {"id":784,"alpha2":"ae","alpha3":"are","name":"Förenade Arabemiraten"},
    {"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},
    {"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},
    {"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgien"},
    {"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},
    {"id":276,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},
    {"id":300,"alpha2":"gr","alpha3":"grc","name":"Grekland"},
    {"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},
    {"id":304,"alpha2":"gl","alpha3":"grl","name":"Grönland"},
    {"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},
    {"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},
    {"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bissau"},
    {"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},
    {"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},
    {"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},
    {"id":356,"alpha2":"in","alpha3":"ind","name":"Indien"},
    {"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesien"},
    {"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},
    {"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},
    {"id":372,"alpha2":"ie","alpha3":"irl","name":"Irland"},
    {"id":352,"alpha2":"is","alpha3":"isl","name":"Island"},
    {"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},
    {"id":380,"alpha2":"it","alpha3":"ita","name":"Italien"},
    {"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},
    {"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japan"},
    {"id":887,"alpha2":"ye","alpha3":"yem","name":"Jemen"},
    {"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordanien"},
    {"id":116,"alpha2":"kh","alpha3":"khm","name":"Kambodja"},
    {"id":120,"alpha2":"cm","alpha3":"cmr","name":"Kamerun"},
    {"id":124,"alpha2":"ca","alpha3":"can","name":"Kanada"},
    {"id":9001,"alpha2":"ic","alpha3":"ic","name":"Kanarieöarna"},
    {"id":132,"alpha2":"cv","alpha3":"cpv","name":"Kap Verde"},
    {"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazakstan"},
    {"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenya"},
    {"id":156,"alpha2":"cn","alpha3":"chn","name":"Kina"},
    {"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirgizistan"},
    {"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},
    {"id":174,"alpha2":"km","alpha3":"com","name":"Komorerna"},
    {"id":178,"alpha2":"cg","alpha3":"cog","name":"Kongo-Brazzaville"},
    {"id":180,"alpha2":"cd","alpha3":"cod","name":"Kongo-Kinshasa"},
    {"id":383,"alpha2":"xk","alpha3":"xkx","name":"Kosovo"},
    {"id":191,"alpha2":"hr","alpha3":"hrv","name":"Kroatien"},
    {"id":192,"alpha2":"cu","alpha3":"cub","name":"Kuba"},
    {"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},
    {"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},
    {"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},
    {"id":428,"alpha2":"lv","alpha3":"lva","name":"Lettland"},
    {"id":422,"alpha2":"lb","alpha3":"lbn","name":"Libanon"},
    {"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},
    {"id":434,"alpha2":"ly","alpha3":"lby","name":"Libyen"},
    {"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},
    {"id":440,"alpha2":"lt","alpha3":"ltu","name":"Litauen"},
    {"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburg"},
    {"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagaskar"},
    {"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},
    {"id":458,"alpha2":"my","alpha3":"mys","name":"Malaysia"},
    {"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldiverna"},
    {"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},
    {"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},
    {"id":504,"alpha2":"ma","alpha3":"mar","name":"Marocko"},
    {"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshallöarna"},
    {"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauretanien"},
    {"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},
    {"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexiko"},
    {"id":583,"alpha2":"fm","alpha3":"fsm","name":"Mikronesien"},
    {"id":508,"alpha2":"mz","alpha3":"moz","name":"Moçambique"},
    {"id":498,"alpha2":"md","alpha3":"mda","name":"Moldavien"},
    {"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},
    {"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongoliet"},
    {"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},
    {"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},
    {"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},
    {"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},
    {"id":528,"alpha2":"nl","alpha3":"nld","name":"Nederländerna"},
    {"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},
    {"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},
    {"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},
    {"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},
    {"id":408,"alpha2":"kp","alpha3":"prk","name":"Nordkorea"},
    {"id":807,"alpha2":"mk","alpha3":"mkd","name":"Nordmakedonien"},
    {"id":578,"alpha2":"no","alpha3":"nor","name":"Norge"},
    {"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nya Zeeland"},
    {"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},
    {"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},
    {"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},
    {"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},
    {"id":598,"alpha2":"pg","alpha3":"png","name":"Papua Nya Guinea"},
    {"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},
    {"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},
    {"id":616,"alpha2":"pl","alpha3":"pol","name":"Polen"},
    {"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},
    {"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},
    {"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},
    {"id":642,"alpha2":"ro","alpha3":"rou","name":"Rumänien"},
    {"id":646,"alpha2":"rw","alpha3":"rwa","name":"Rwanda"},
    {"id":643,"alpha2":"ru","alpha3":"rus","name":"Ryssland"},
    {"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint Kitts och Nevis"},
    {"id":662,"alpha2":"lc","alpha3":"lca","name":"Saint Lucia"},
    {"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint Vincent och Grenadinerna"},
    {"id":90,"alpha2":"sb","alpha3":"slb","name":"Salomonöarna"},
    {"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},
    {"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},
    {"id":678,"alpha2":"st","alpha3":"stp","name":"São Tomé och Príncipe"},
    {"id":682,"alpha2":"sa","alpha3":"sau","name":"Saudiarabien"},
    {"id":756,"alpha2":"ch","alpha3":"che","name":"Schweiz"},
    {"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},
    {"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbien"},
    {"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychellerna"},
    {"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},
    {"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapore"},
    {"id":703,"alpha2":"sk","alpha3":"svk","name":"Slovakien"},
    {"id":705,"alpha2":"si","alpha3":"svn","name":"Slovenien"},
    {"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},
    {"id":724,"alpha2":"es","alpha3":"esp","name":"Spanien"},
    {"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},
    {"id":826,"alpha2":"gb","alpha3":"gbr","name":"Storbritannien"},
    {"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudan"},
    {"id":740,"alpha2":"sr","alpha3":"sur","name":"Surinam"},
    {"id":752,"alpha2":"se","alpha3":"swe","name":"Sverige"},
    {"id":710,"alpha2":"za","alpha3":"zaf","name":"Sydafrika"},
    {"id":410,"alpha2":"kr","alpha3":"kor","name":"Sydkorea"},
    {"id":728,"alpha2":"ss","alpha3":"ssd","name":"Sydsudan"},
    {"id":760,"alpha2":"sy","alpha3":"syr","name":"Syrien"},
    {"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadzjikistan"},
    {"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania"},
    {"id":148,"alpha2":"td","alpha3":"tcd","name":"Tchad"},
    {"id":764,"alpha2":"th","alpha3":"tha","name":"Thailand"},
    {"id":203,"alpha2":"cz","alpha3":"cze","name":"Tjeckien"},
    {"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},
    {"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},
    {"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad och Tobago"},
    {"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunisien"},
    {"id":792,"alpha2":"tr","alpha3":"tur","name":"Turkiet"},
    {"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},
    {"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},
    {"id":276,"alpha2":"de","alpha3":"deu","name":"Tyskland"},
    {"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},
    {"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraina"},
    {"id":348,"alpha2":"hu","alpha3":"hun","name":"Ungern"},
    {"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},
    {"id":840,"alpha2":"us","alpha3":"usa","name":"USA"},
    {"id":860,"alpha2":"uz","alpha3":"uzb","name":"Uzbekistan"},
    {"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},
    {"id":336,"alpha2":"va","alpha3":"vat","name":"Vatikanstaten"},
    {"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},
    {"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},
    {"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},
    {"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"},
    {"id":40,"alpha2":"at","alpha3":"aut","name":"Österrike"},
    {"id":626,"alpha2":"tl","alpha3":"tls","name":"Östtimor"},
    ];
};
const countryListDA = (includeEU = false) => {
    return [
    {"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},
    {"id":8,"alpha2":"al","alpha3":"alb","name":"Albanien"},
    {"id":12,"alpha2":"dz","alpha3":"dza","name":"Algeriet"},
    {"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},
    {"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},
    {"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua og Barbuda"},
    {"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},
    {"id":51,"alpha2":"am","alpha3":"arm","name":"Armenien"},
    {"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},
    {"id":31,"alpha2":"az","alpha3":"aze","name":"Aserbajdsjan"},
    {"id":36,"alpha2":"au","alpha3":"aus","name":"Australien"},
    {"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},
    {"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrain"},
    {"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},
    {"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},
    {"id":56,"alpha2":"be","alpha3":"bel","name":"Belgien"},
    {"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},
    {"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},
    {"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},
    {"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia"},
    {"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, Sint Eustatius og Saba"},
    {"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnien-Hercegovina"},
    {"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},
    {"id":76,"alpha2":"br","alpha3":"bra","name":"Brasilien"},
    {"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},
    {"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgarien"},
    {"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},
    {"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},
    {"id":116,"alpha2":"kh","alpha3":"khm","name":"Cambodja"},
    {"id":120,"alpha2":"cm","alpha3":"cmr","name":"Cameroun"},
    {"id":124,"alpha2":"ca","alpha3":"can","name":"Canada"},
    {"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},
    {"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},
    {"id":174,"alpha2":"km","alpha3":"com","name":"Comorerne"},
    {"id":178,"alpha2":"cg","alpha3":"cog","name":"Congo"},
    {"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},
    {"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},
    {"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},
    {"id":196,"alpha2":"cy","alpha3":"cyp","name":"Cypern"},
    {"id":208,"alpha2":"dk","alpha3":"dnk","name":"Danmark"},
    {"id":784,"alpha2":"ae","alpha3":"are","name":"De Forenede Arabiske Emirater"},
    {"id":9001,"alpha2":"ic","alpha3":"ic","name":"De Kanariske Øer"},
    {"id":140,"alpha2":"cf","alpha3":"caf","name":"Den Centralafrikanske Republik"},
    {"id":180,"alpha2":"cd","alpha3":"cod","name":"Den Demokratiske Republik Congo"},
    {"id":214,"alpha2":"do","alpha3":"dom","name":"Den Dominikanske Republik"},
    ...(includeEU ? [{"id":999,"alpha2":"eu","alpha3":"eur","name":"Den Europæiske Union"}] : []),
    {"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},
    {"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},
    {"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},
    {"id":818,"alpha2":"eg","alpha3":"egy","name":"Egypten"},
    {"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},
    {"id":384,"alpha2":"ci","alpha3":"civ","name":"Elfenbenskysten"},
    {"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},
    {"id":233,"alpha2":"ee","alpha3":"est","name":"Estland"},
    {"id":748,"alpha2":"sz","alpha3":"swz","name":"Eswatini"},
    {"id":231,"alpha2":"et","alpha3":"eth","name":"Etiopien"},
    {"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiji"},
    {"id":608,"alpha2":"ph","alpha3":"phl","name":"Filippinerne"},
    {"id":246,"alpha2":"fi","alpha3":"fin","name":"Finland"},
    {"id":250,"alpha2":"fr","alpha3":"fra","name":"Frankrig"},
    {"id":234,"alpha2":"fo","alpha3":"fro","name":"Færøerne"},
    {"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},
    {"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},
    {"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgien"},
    {"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},
    {"id":276,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},
    {"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},
    {"id":300,"alpha2":"gr","alpha3":"grc","name":"Grækenland"},
    {"id":304,"alpha2":"gl","alpha3":"grl","name":"Grønland"},
    {"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},
    {"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},
    {"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bissau"},
    {"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},
    {"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},
    {"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},
    {"id":112,"alpha2":"by","alpha3":"blr","name":"Hviderusland"},
    {"id":356,"alpha2":"in","alpha3":"ind","name":"Indien"},
    {"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesien"},
    {"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},
    {"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},
    {"id":372,"alpha2":"ie","alpha3":"irl","name":"Irland"},
    {"id":352,"alpha2":"is","alpha3":"isl","name":"Island"},
    {"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},
    {"id":380,"alpha2":"it","alpha3":"ita","name":"Italien"},
    {"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},
    {"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japan"},
    {"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordan"},
    {"id":132,"alpha2":"cv","alpha3":"cpv","name":"Kap Verde"},
    {"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kasakhstan"},
    {"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenya"},
    {"id":156,"alpha2":"cn","alpha3":"chn","name":"Kina"},
    {"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirgisistan"},
    {"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},
    {"id":383,"alpha2":"xk","alpha3":"xkx","name":"Kosovo"},
    {"id":191,"alpha2":"hr","alpha3":"hrv","name":"Kroatien"},
    {"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},
    {"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},
    {"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},
    {"id":428,"alpha2":"lv","alpha3":"lva","name":"Letland"},
    {"id":422,"alpha2":"lb","alpha3":"lbn","name":"Libanon"},
    {"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},
    {"id":434,"alpha2":"ly","alpha3":"lby","name":"Libyen"},
    {"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},
    {"id":440,"alpha2":"lt","alpha3":"ltu","name":"Litauen"},
    {"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxembourg"},
    {"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagaskar"},
    {"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},
    {"id":458,"alpha2":"my","alpha3":"mys","name":"Malaysia"},
    {"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldiverne"},
    {"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},
    {"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},
    {"id":504,"alpha2":"ma","alpha3":"mar","name":"Marokko"},
    {"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshalløerne"},
    {"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauretanien"},
    {"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},
    {"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexico"},
    {"id":583,"alpha2":"fm","alpha3":"fsm","name":"Mikronesien"},
    {"id":498,"alpha2":"md","alpha3":"mda","name":"Moldova"},
    {"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},
    {"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongoliet"},
    {"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},
    {"id":508,"alpha2":"mz","alpha3":"moz","name":"Mozambique"},
    {"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},
    {"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},
    {"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},
    {"id":528,"alpha2":"nl","alpha3":"nld","name":"Nederlandene"},
    {"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},
    {"id":554,"alpha2":"nz","alpha3":"nzl","name":"New Zealand"},
    {"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},
    {"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},
    {"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},
    {"id":408,"alpha2":"kp","alpha3":"prk","name":"Nordkorea"},
    {"id":807,"alpha2":"mk","alpha3":"mkd","name":"Nordmakedonien"},
    {"id":578,"alpha2":"no","alpha3":"nor","name":"Norge"},
    {"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},
    {"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},
    {"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},
    {"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},
    {"id":598,"alpha2":"pg","alpha3":"png","name":"Papua Ny Guinea"},
    {"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},
    {"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},
    {"id":616,"alpha2":"pl","alpha3":"pol","name":"Polen"},
    {"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},
    {"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},
    {"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},
    {"id":642,"alpha2":"ro","alpha3":"rou","name":"Rumænien"},
    {"id":643,"alpha2":"ru","alpha3":"rus","name":"Rusland"},
    {"id":646,"alpha2":"rw","alpha3":"rwa","name":"Rwanda"},
    {"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint Kitts og Nevis"},
    {"id":662,"alpha2":"lc","alpha3":"lca","name":"Saint Lucia"},
    {"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint Vincent og Grenadinerne"},
    {"id":90,"alpha2":"sb","alpha3":"slb","name":"Salomonøerne"},
    {"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},
    {"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},
    {"id":678,"alpha2":"st","alpha3":"stp","name":"São Tomé og Príncipe"},
    {"id":682,"alpha2":"sa","alpha3":"sau","name":"Saudi-Arabien"},
    {"id":756,"alpha2":"ch","alpha3":"che","name":"Schweiz"},
    {"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},
    {"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbien"},
    {"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychellerne"},
    {"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},
    {"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapore"},
    {"id":703,"alpha2":"sk","alpha3":"svk","name":"Slovakiet"},
    {"id":705,"alpha2":"si","alpha3":"svn","name":"Slovenien"},
    {"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},
    {"id":724,"alpha2":"es","alpha3":"esp","name":"Spanien"},
    {"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},
    {"id":826,"alpha2":"gb","alpha3":"gbr","name":"Storbritannien"},
    {"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudan"},
    {"id":740,"alpha2":"sr","alpha3":"sur","name":"Surinam"},
    {"id":752,"alpha2":"se","alpha3":"swe","name":"Sverige"},
    {"id":710,"alpha2":"za","alpha3":"zaf","name":"Sydafrika"},
    {"id":410,"alpha2":"kr","alpha3":"kor","name":"Sydkorea"},
    {"id":728,"alpha2":"ss","alpha3":"ssd","name":"Sydsudan"},
    {"id":760,"alpha2":"sy","alpha3":"syr","name":"Syrien"},
    {"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadsjikistan"},
    {"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania"},
    {"id":148,"alpha2":"td","alpha3":"tcd","name":"Tchad"},
    {"id":764,"alpha2":"th","alpha3":"tha","name":"Thailand"},
    {"id":203,"alpha2":"cz","alpha3":"cze","name":"Tjekkiet"},
    {"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},
    {"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},
    {"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad og Tobago"},
    {"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunesien"},
    {"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},
    {"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},
    {"id":792,"alpha2":"tr","alpha3":"tur","name":"Tyrkiet"},
    {"id":276,"alpha2":"de","alpha3":"deu","name":"Tyskland"},
    {"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},
    {"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraine"},
    {"id":348,"alpha2":"hu","alpha3":"hun","name":"Ungarn"},
    {"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},
    {"id":840,"alpha2":"us","alpha3":"usa","name":"USA"},
    {"id":860,"alpha2":"uz","alpha3":"uzb","name":"Usbekistan"},
    {"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},
    {"id":336,"alpha2":"va","alpha3":"vat","name":"Vatikanstaten"},
    {"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},
    {"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},
    {"id":887,"alpha2":"ye","alpha3":"yem","name":"Yemen"},
    {"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},
    {"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"},
    {"id":226,"alpha2":"gq","alpha3":"gnq","name":"Ækvatorialguinea"},
    {"id":40,"alpha2":"at","alpha3":"aut","name":"Østrig"},
    {"id":626,"alpha2":"tl","alpha3":"tls","name":"Østtimor"},
    ];
};
const countryListNB = (includeEU = false) => {
    return [
    {"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},
    {"id":8,"alpha2":"al","alpha3":"alb","name":"Albania"},
    {"id":12,"alpha2":"dz","alpha3":"dza","name":"Algerie"},
    {"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},
    {"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},
    {"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua og Barbuda"},
    {"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},
    {"id":51,"alpha2":"am","alpha3":"arm","name":"Armenia"},
    {"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},
    {"id":31,"alpha2":"az","alpha3":"aze","name":"Aserbajdsjan"},
    {"id":36,"alpha2":"au","alpha3":"aus","name":"Australia"},
    {"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},
    {"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrain"},
    {"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},
    {"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},
    {"id":112,"alpha2":"by","alpha3":"blr","name":"Belarus"},
    {"id":56,"alpha2":"be","alpha3":"bel","name":"Belgia"},
    {"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},
    {"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},
    {"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},
    {"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia"},
    {"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, Sint Eustatius og Saba"},
    {"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnia-Hercegovina"},
    {"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},
    {"id":76,"alpha2":"br","alpha3":"bra","name":"Brasil"},
    {"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},
    {"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgaria"},
    {"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},
    {"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},
    {"id":124,"alpha2":"ca","alpha3":"can","name":"Canada"},
    {"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},
    {"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},
    {"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},
    {"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},
    {"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},
    {"id":208,"alpha2":"dk","alpha3":"dnk","name":"Danmark"},
    {"id":784,"alpha2":"ae","alpha3":"are","name":"De forente arabiske emirater"},
    {"id":180,"alpha2":"cd","alpha3":"cod","name":"Den demokratiske republikken Kongo"},
    {"id":214,"alpha2":"do","alpha3":"dom","name":"Den dominikanske republikk"},
    ...(includeEU ? [{"id":999,"alpha2":"eu","alpha3":"eur","name":"Den europeiske union"}] : []),
    {"id":140,"alpha2":"cf","alpha3":"caf","name":"Den sentralafrikanske republikk"},
    {"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},
    {"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},
    {"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},
    {"id":818,"alpha2":"eg","alpha3":"egy","name":"Egypt"},
    {"id":226,"alpha2":"gq","alpha3":"gnq","name":"Ekvatorial-Guinea"},
    {"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},
    {"id":384,"alpha2":"ci","alpha3":"civ","name":"Elfenbenskysten"},
    {"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},
    {"id":233,"alpha2":"ee","alpha3":"est","name":"Estland"},
    {"id":748,"alpha2":"sz","alpha3":"swz","name":"Eswatini"},
    {"id":231,"alpha2":"et","alpha3":"eth","name":"Etiopia"},
    {"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiji"},
    {"id":608,"alpha2":"ph","alpha3":"phl","name":"Filippinene"},
    {"id":246,"alpha2":"fi","alpha3":"fin","name":"Finland"},
    {"id":250,"alpha2":"fr","alpha3":"fra","name":"Frankrike"},
    {"id":234,"alpha2":"fo","alpha3":"fro","name":"Færøyene"},
    {"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},
    {"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},
    {"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgia"},
    {"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},
    {"id":276,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},
    {"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},
    {"id":304,"alpha2":"gl","alpha3":"grl","name":"Grønland"},
    {"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},
    {"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},
    {"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bissau"},
    {"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},
    {"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},
    {"id":300,"alpha2":"gr","alpha3":"grc","name":"Hellas"},
    {"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},
    {"id":356,"alpha2":"in","alpha3":"ind","name":"India"},
    {"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesia"},
    {"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},
    {"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},
    {"id":372,"alpha2":"ie","alpha3":"irl","name":"Irland"},
    {"id":352,"alpha2":"is","alpha3":"isl","name":"Island"},
    {"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},
    {"id":380,"alpha2":"it","alpha3":"ita","name":"Italia"},
    {"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},
    {"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japan"},
    {"id":887,"alpha2":"ye","alpha3":"yem","name":"Jemen"},
    {"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordan"},
    {"id":116,"alpha2":"kh","alpha3":"khm","name":"Kambodsja"},
    {"id":120,"alpha2":"cm","alpha3":"cmr","name":"Kamerun"},
    {"id":9001,"alpha2":"ic","alpha3":"ic","name":"Kanariøyene"},
    {"id":132,"alpha2":"cv","alpha3":"cpv","name":"Kapp Verde"},
    {"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kasakhstan"},
    {"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenya"},
    {"id":156,"alpha2":"cn","alpha3":"chn","name":"Kina"},
    {"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirgisistan"},
    {"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},
    {"id":174,"alpha2":"km","alpha3":"com","name":"Komorene"},
    {"id":383,"alpha2":"xk","alpha3":"xkx","name":"Kosovo"},
    {"id":191,"alpha2":"hr","alpha3":"hrv","name":"Kroatia"},
    {"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},
    {"id":196,"alpha2":"cy","alpha3":"cyp","name":"Kypros"},
    {"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},
    {"id":428,"alpha2":"lv","alpha3":"lva","name":"Latvia"},
    {"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},
    {"id":422,"alpha2":"lb","alpha3":"lbn","name":"Libanon"},
    {"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},
    {"id":434,"alpha2":"ly","alpha3":"lby","name":"Libya"},
    {"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},
    {"id":440,"alpha2":"lt","alpha3":"ltu","name":"Litauen"},
    {"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxembourg"},
    {"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagaskar"},
    {"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},
    {"id":458,"alpha2":"my","alpha3":"mys","name":"Malaysia"},
    {"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldivene"},
    {"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},
    {"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},
    {"id":504,"alpha2":"ma","alpha3":"mar","name":"Marokko"},
    {"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshalløyene"},
    {"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritania"},
    {"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},
    {"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexico"},
    {"id":583,"alpha2":"fm","alpha3":"fsm","name":"Mikronesiaføderasjonen"},
    {"id":498,"alpha2":"md","alpha3":"mda","name":"Moldova"},
    {"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},
    {"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolia"},
    {"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},
    {"id":508,"alpha2":"mz","alpha3":"moz","name":"Mosambik"},
    {"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},
    {"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},
    {"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},
    {"id":528,"alpha2":"nl","alpha3":"nld","name":"Nederland"},
    {"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},
    {"id":554,"alpha2":"nz","alpha3":"nzl","name":"New Zealand"},
    {"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},
    {"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},
    {"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},
    {"id":408,"alpha2":"kp","alpha3":"prk","name":"Nord-Korea"},
    {"id":807,"alpha2":"mk","alpha3":"mkd","name":"Nord-Makedonia"},
    {"id":578,"alpha2":"no","alpha3":"nor","name":"Norge"},
    {"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},
    {"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},
    {"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},
    {"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},
    {"id":598,"alpha2":"pg","alpha3":"png","name":"Papua Ny-Guinea"},
    {"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},
    {"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},
    {"id":616,"alpha2":"pl","alpha3":"pol","name":"Polen"},
    {"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},
    {"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},
    {"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},
    {"id":178,"alpha2":"cg","alpha3":"cog","name":"Republikken Kongo"},
    {"id":642,"alpha2":"ro","alpha3":"rou","name":"Romania"},
    {"id":643,"alpha2":"ru","alpha3":"rus","name":"Russland"},
    {"id":646,"alpha2":"rw","alpha3":"rwa","name":"Rwanda"},
    {"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint Kitts og Nevis"},
    {"id":662,"alpha2":"lc","alpha3":"lca","name":"Saint Lucia"},
    {"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint Vincent og Grenadinene"},
    {"id":90,"alpha2":"sb","alpha3":"slb","name":"Salomonøyene"},
    {"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},
    {"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},
    {"id":678,"alpha2":"st","alpha3":"stp","name":"São Tomé og Príncipe"},
    {"id":682,"alpha2":"sa","alpha3":"sau","name":"Saudi-Arabia"},
    {"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},
    {"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbia"},
    {"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychellene"},
    {"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},
    {"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapore"},
    {"id":703,"alpha2":"sk","alpha3":"svk","name":"Slovakia"},
    {"id":705,"alpha2":"si","alpha3":"svn","name":"Slovenia"},
    {"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},
    {"id":724,"alpha2":"es","alpha3":"esp","name":"Spania"},
    {"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},
    {"id":826,"alpha2":"gb","alpha3":"gbr","name":"Storbritannia"},
    {"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudan"},
    {"id":740,"alpha2":"sr","alpha3":"sur","name":"Surinam"},
    {"id":756,"alpha2":"ch","alpha3":"che","name":"Sveits"},
    {"id":752,"alpha2":"se","alpha3":"swe","name":"Sverige"},
    {"id":760,"alpha2":"sy","alpha3":"syr","name":"Syria"},
    {"id":710,"alpha2":"za","alpha3":"zaf","name":"Sør-Afrika"},
    {"id":410,"alpha2":"kr","alpha3":"kor","name":"Sør-Korea"},
    {"id":728,"alpha2":"ss","alpha3":"ssd","name":"Sør-Sudan"},
    {"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadsjikistan"},
    {"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania"},
    {"id":764,"alpha2":"th","alpha3":"tha","name":"Thailand"},
    {"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},
    {"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},
    {"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad og Tobago"},
    {"id":148,"alpha2":"td","alpha3":"tcd","name":"Tsjad"},
    {"id":203,"alpha2":"cz","alpha3":"cze","name":"Tsjekkia"},
    {"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunisia"},
    {"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},
    {"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},
    {"id":792,"alpha2":"tr","alpha3":"tur","name":"Tyrkia"},
    {"id":276,"alpha2":"de","alpha3":"deu","name":"Tyskland"},
    {"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},
    {"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraina"},
    {"id":348,"alpha2":"hu","alpha3":"hun","name":"Ungarn"},
    {"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},
    {"id":840,"alpha2":"us","alpha3":"usa","name":"USA"},
    {"id":860,"alpha2":"uz","alpha3":"uzb","name":"Usbekistan"},
    {"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},
    {"id":336,"alpha2":"va","alpha3":"vat","name":"Vatikanstaten"},
    {"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},
    {"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},
    {"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},
    {"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"},
    {"id":626,"alpha2":"tl","alpha3":"tls","name":"Øst-Timor"},
    {"id":40,"alpha2":"at","alpha3":"aut","name":"Østerrike"},
    ];
};
const countryListFI = (includeEU = false) => {
    return [
    {"id":4,"alpha2":"af","alpha3":"afg","name":"Afganistan"},
    {"id":528,"alpha2":"nl","alpha3":"nld","name":"Alankomaat"},
    {"id":8,"alpha2":"al","alpha3":"alb","name":"Albania"},
    {"id":12,"alpha2":"dz","alpha3":"dza","name":"Algeria"},
    {"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},
    {"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},
    {"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua ja Barbuda"},
    {"id":784,"alpha2":"ae","alpha3":"are","name":"Arabiemiirikunnat"},
    {"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentiina"},
    {"id":51,"alpha2":"am","alpha3":"arm","name":"Armenia"},
    {"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},
    {"id":36,"alpha2":"au","alpha3":"aus","name":"Australia"},
    {"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbaidžan"},
    {"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahama"},
    {"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrain"},
    {"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},
    {"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},
    {"id":56,"alpha2":"be","alpha3":"bel","name":"Belgia"},
    {"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},
    {"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},
    {"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},
    {"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia"},
    {"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, Sint Eustatius ja Saba"},
    {"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnia ja Hertsegovina"},
    {"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},
    {"id":76,"alpha2":"br","alpha3":"bra","name":"Brasilia"},
    {"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},
    {"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgaria"},
    {"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},
    {"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},
    {"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},
    {"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},
    {"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},
    {"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},
    {"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},
    {"id":214,"alpha2":"do","alpha3":"dom","name":"Dominikaaninen tasavalta"},
    {"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},
    {"id":818,"alpha2":"eg","alpha3":"egy","name":"Egypti"},
    {"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},
    {"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},
    {"id":724,"alpha2":"es","alpha3":"esp","name":"Espanja"},
    {"id":748,"alpha2":"sz","alpha3":"swz","name":"Eswatini"},
    {"id":710,"alpha2":"za","alpha3":"zaf","name":"Etelä-Afrikka"},
    {"id":410,"alpha2":"kr","alpha3":"kor","name":"Etelä-Korea"},
    {"id":728,"alpha2":"ss","alpha3":"ssd","name":"Etelä-Sudan"},
    {"id":231,"alpha2":"et","alpha3":"eth","name":"Etiopia"},
    ...(includeEU ? [{"id":999,"alpha2":"eu","alpha3":"eur","name":"Euroopan unioni"}] : []),
    {"id":242,"alpha2":"fj","alpha3":"fji","name":"Fidži"},
    {"id":608,"alpha2":"ph","alpha3":"phl","name":"Filippiinit"},
    {"id":234,"alpha2":"fo","alpha3":"fro","name":"Färsaaret"},
    {"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},
    {"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},
    {"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgia"},
    {"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},
    {"id":276,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},
    {"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},
    {"id":304,"alpha2":"gl","alpha3":"grl","name":"Grönlanti"},
    {"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},
    {"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},
    {"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bissau"},
    {"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},
    {"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},
    {"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},
    {"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesia"},
    {"id":356,"alpha2":"in","alpha3":"ind","name":"Intia"},
    {"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},
    {"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},
    {"id":372,"alpha2":"ie","alpha3":"irl","name":"Irlanti"},
    {"id":352,"alpha2":"is","alpha3":"isl","name":"Islanti"},
    {"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},
    {"id":380,"alpha2":"it","alpha3":"ita","name":"Italia"},
    {"id":626,"alpha2":"tl","alpha3":"tls","name":"Itä-Timor"},
    {"id":40,"alpha2":"at","alpha3":"aut","name":"Itävalta"},
    {"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaika"},
    {"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japani"},
    {"id":887,"alpha2":"ye","alpha3":"yem","name":"Jemen"},
    {"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordania"},
    {"id":116,"alpha2":"kh","alpha3":"khm","name":"Kambodža"},
    {"id":120,"alpha2":"cm","alpha3":"cmr","name":"Kamerun"},
    {"id":124,"alpha2":"ca","alpha3":"can","name":"Kanada"},
    {"id":9001,"alpha2":"ic","alpha3":"ic","name":"Kanariansaaret"},
    {"id":132,"alpha2":"cv","alpha3":"cpv","name":"Kap Verde"},
    {"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazakstan"},
    {"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenia"},
    {"id":140,"alpha2":"cf","alpha3":"caf","name":"Keski-Afrikan tasavalta"},
    {"id":156,"alpha2":"cn","alpha3":"chn","name":"Kiina"},
    {"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirgisia"},
    {"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},
    {"id":170,"alpha2":"co","alpha3":"col","name":"Kolumbia"},
    {"id":174,"alpha2":"km","alpha3":"com","name":"Komorit"},
    {"id":178,"alpha2":"cg","alpha3":"cog","name":"Kongo-Brazzaville"},
    {"id":180,"alpha2":"cd","alpha3":"cod","name":"Kongon demokraattinen tasavalta"},
    {"id":383,"alpha2":"xk","alpha3":"xkx","name":"Kosovo"},
    {"id":300,"alpha2":"gr","alpha3":"grc","name":"Kreikka"},
    {"id":191,"alpha2":"hr","alpha3":"hrv","name":"Kroatia"},
    {"id":192,"alpha2":"cu","alpha3":"cub","name":"Kuuba"},
    {"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},
    {"id":196,"alpha2":"cy","alpha3":"cyp","name":"Kypros"},
    {"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},
    {"id":428,"alpha2":"lv","alpha3":"lva","name":"Latvia"},
    {"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},
    {"id":422,"alpha2":"lb","alpha3":"lbn","name":"Libanon"},
    {"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},
    {"id":434,"alpha2":"ly","alpha3":"lby","name":"Libya"},
    {"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},
    {"id":440,"alpha2":"lt","alpha3":"ltu","name":"Liettua"},
    {"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburg"},
    {"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagaskar"},
    {"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},
    {"id":462,"alpha2":"mv","alpha3":"mdv","name":"Malediivit"},
    {"id":458,"alpha2":"my","alpha3":"mys","name":"Malesia"},
    {"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},
    {"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},
    {"id":504,"alpha2":"ma","alpha3":"mar","name":"Marokko"},
    {"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshallinsaaret"},
    {"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritania"},
    {"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},
    {"id":484,"alpha2":"mx","alpha3":"mex","name":"Meksiko"},
    {"id":583,"alpha2":"fm","alpha3":"fsm","name":"Mikronesia"},
    {"id":498,"alpha2":"md","alpha3":"mda","name":"Moldova"},
    {"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},
    {"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolia"},
    {"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},
    {"id":508,"alpha2":"mz","alpha3":"moz","name":"Mosambik"},
    {"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},
    {"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},
    {"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},
    {"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},
    {"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},
    {"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},
    {"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},
    {"id":578,"alpha2":"no","alpha3":"nor","name":"Norja"},
    {"id":384,"alpha2":"ci","alpha3":"civ","name":"Norsunluurannikko"},
    {"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},
    {"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},
    {"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},
    {"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},
    {"id":598,"alpha2":"pg","alpha3":"png","name":"Papua-Uusi-Guinea"},
    {"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},
    {"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},
    {"id":408,"alpha2":"kp","alpha3":"prk","name":"Pohjois-Korea"},
    {"id":807,"alpha2":"mk","alpha3":"mkd","name":"Pohjois-Makedonia"},
    {"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugali"},
    {"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},
    {"id":616,"alpha2":"pl","alpha3":"pol","name":"Puola"},
    {"id":226,"alpha2":"gq","alpha3":"gnq","name":"Päiväntasaajan Guinea"},
    {"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},
    {"id":250,"alpha2":"fr","alpha3":"fra","name":"Ranska"},
    {"id":642,"alpha2":"ro","alpha3":"rou","name":"Romania"},
    {"id":646,"alpha2":"rw","alpha3":"rwa","name":"Ruanda"},
    {"id":752,"alpha2":"se","alpha3":"swe","name":"Ruotsi"},
    {"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint Kitts ja Nevis"},
    {"id":662,"alpha2":"lc","alpha3":"lca","name":"Saint Lucia"},
    {"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint Vincent ja Grenadiinit"},
    {"id":276,"alpha2":"de","alpha3":"deu","name":"Saksa"},
    {"id":90,"alpha2":"sb","alpha3":"slb","name":"Salomonsaaret"},
    {"id":894,"alpha2":"zm","alpha3":"zmb","name":"Sambia"},
    {"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},
    {"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},
    {"id":678,"alpha2":"st","alpha3":"stp","name":"São Tomé ja Príncipe"},
    {"id":682,"alpha2":"sa","alpha3":"sau","name":"Saudi-Arabia"},
    {"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},
    {"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbia"},
    {"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychellit"},
    {"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},
    {"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapore"},
    {"id":703,"alpha2":"sk","alpha3":"svk","name":"Slovakia"},
    {"id":705,"alpha2":"si","alpha3":"svn","name":"Slovenia"},
    {"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},
    {"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},
    {"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudan"},
    {"id":246,"alpha2":"fi","alpha3":"fin","name":"Suomi"},
    {"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},
    {"id":756,"alpha2":"ch","alpha3":"che","name":"Sveitsi"},
    {"id":760,"alpha2":"sy","alpha3":"syr","name":"Syyria"},
    {"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadžikistan"},
    {"id":834,"alpha2":"tz","alpha3":"tza","name":"Tansania"},
    {"id":208,"alpha2":"dk","alpha3":"dnk","name":"Tanska"},
    {"id":764,"alpha2":"th","alpha3":"tha","name":"Thaimaa"},
    {"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},
    {"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},
    {"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad ja Tobago"},
    {"id":148,"alpha2":"td","alpha3":"tcd","name":"Tšad"},
    {"id":203,"alpha2":"cz","alpha3":"cze","name":"Tšekki"},
    {"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunisia"},
    {"id":792,"alpha2":"tr","alpha3":"tur","name":"Turkki"},
    {"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},
    {"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},
    {"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},
    {"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraina"},
    {"id":348,"alpha2":"hu","alpha3":"hun","name":"Unkari"},
    {"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},
    {"id":554,"alpha2":"nz","alpha3":"nzl","name":"Uusi-Seelanti"},
    {"id":860,"alpha2":"uz","alpha3":"uzb","name":"Uzbekistan"},
    {"id":112,"alpha2":"by","alpha3":"blr","name":"Valko-Venäjä"},
    {"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},
    {"id":336,"alpha2":"va","alpha3":"vat","name":"Vatikaani"},
    {"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},
    {"id":643,"alpha2":"ru","alpha3":"rus","name":"Venäjä"},
    {"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},
    {"id":233,"alpha2":"ee","alpha3":"est","name":"Viro"},
    {"id":826,"alpha2":"gb","alpha3":"gbr","name":"Yhdistynyt kuningaskunta"},
    {"id":840,"alpha2":"us","alpha3":"usa","name":"Yhdysvallat"},
    {"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"},
    ];
};
